import ExcelJS from "exceljs";
import _ from "lodash";
import { getCareerAvailableYears } from "../lib/cvDataUtilities.js";
import {
  getDate,
  getItemsWithinDateRange,
  getYears,
  isTimeWithinRange
} from "../lib/dateHelpers.js";
import { escapeHtml, getProp } from "../lib/frontendUtilities.js";
import { getLastPosition } from "../lib/reportUtilities.js";
import { getField, getKey, keys } from "../lib/utilities.js";
import { CCManage } from "./cclib/CCManage.ts";

var sortBy = "mentor";
var mentees = [];

var apawStructure = [
  {
    name: "Education",
    sections: [
      {
        name: "Medical Student Related Education",
        list: [
          {
            name: "Host to Non-Medical Student Shawdowing Experience",
            key: "education1",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Anesthesia Interest Group Meeting Attendance",
            key: "education2",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Repeat lecture to Medical Students - PreClerkship",
            key: "education3",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "New lecture (classroom) to Medical Students - PreClerkship",
            key: "education4",
            unit: "",
            value: "4",
            score: (num) => num * 4
          },
          {
            name: "Workshop Instructor for Medical Students",
            key: "education5",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Workshop Coordinator for Medical Students",
            key: "education6",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Medical Student Rotation Director",
            key: "education7",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Med student case presentaton moderator session ",
            key: "education8",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Entrustable Professional Activity",
            key: "education9",
            unit: "",
            value: "0.1",
            score: (num) => num * 0.1
          },
          {
            name: "Medical student assignments (clinical teaching)",
            key: "education10",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Medical student assignments (performing evalutation)",
            key: "education11",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          }
        ]
      },
      {
        name: "Education Related Awards",
        fields: ["honors"],
        list: [
          {
            name: "Departmental Teaching Award",
            value: "5",
            score: (list) => list.length * 5,
            field: "honors",
            filter: (item) => item.subType == "Departmental Teaching Award"
          },
          {
            name: "Institutional Teaching Award (i.e. Master Educator, Dean's Teaching Award)",
            value: "8",
            score: (list) => list.length * 8,
            field: "honors",
            filter: (item) => item.subType == "Institutional Teaching Award"
          }
        ]
      },
      {
        name: "Presentations",
        fields: ["presentations"],
        list: [
          {
            name: "Repeat lecture to Residents (i.e. Advanced or Basic Board Prep, Monday/Tuesday Conference, Education Day single hour presentation)",
            key: "education12",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "New lecture to Residents",
            key: "education13",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Resident/Fellowship Rotation Director (Elective Rotations)",
            key: "education14",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Resident/Fellowship Rotation Director (Required Rotations)",
            key: "education15",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Workshop Instructor for Non-Physicians",
            key: "education16",
            unit: "",
            value: "0.1",
            score: (num) => num * 0.1
          },
          {
            name: "Workshop Instructor for Residents",
            key: "education17",
            unit: "",
            value: "0.5",
            score: (num) => num * 0.5
          },
          {
            name: "Moderator for a Journal Club",
            key: "education18",
            unit: "",
            value: "0.5",
            score: (num) => num * 0.5
          },
          {
            name: "Repeat lectures to nurses, anesthesia technicians, or other healthcare personnel",
            key: "education19",
            unit: "",
            value: "0.5",
            score: (num) => num * 0.5
          },
          {
            name: "New lectures to nurses, anesthesia technicians, or other healthcare personnel",
            key: "education20",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Grand Rounds lecture within our Department",
            key: "education21",
            unit: "",
            value: "4",
            score: (num) => num * 4
          },
          {
            name: "Grand Rounds Course Director ",
            key: "education22",
            unit: "",
            value: "4",
            score: (num) => num * 4
          },
          {
            name: "Grand Rounds lecture within UVA School of Medicine",
            key: "education23",
            unit: "",
            value: "5",
            score: (num) => num * 5
          },
          {
            name: "Visiting Professor Grand Rounds lecture outside of UVA ",
            key: "education24",
            unit: "",
            value: "6",
            score: (num) => num * 6
          },
          {
            name: "Visiting Professor Journal Club Presentation outside of UVA",
            key: "education25",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Speaker at a Local meeting",
            field: "presentations",
            value: "2",
            score: (list) => list.length * 2,
            filter: (item) =>
              ["Platform", "Invited Lecture"].indexOf(item.presType) >= 0 &&
              item.meetingType == "Local"
          },
          {
            name: "Speaker at a Regional meeting",
            field: "presentations",
            value: "4",
            score: (list) => list.length * 4,
            filter: (item) =>
              ["Platform", "Invited Lecture"].indexOf(item.presType) >= 0 &&
              item.meetingType == "Regional"
          },
          {
            name: "Speaker at a National or International meeting",
            field: "presentations",
            value: "8",
            score: (list) => list.length * 8,
            filter: (item) =>
              ["Platform", "Invited Lecture"].indexOf(item.presType) >= 0 &&
              ["National", "International"].indexOf(item.meetingType) >= 0
          },
          {
            name: "Facilitator of Problem-Based Learning Discussion at Local meeting",
            field: "presentations",
            value: "2",
            score: (list) => list.length * 2,
            filter: (item) =>
              ["PBLD Facilitator"].indexOf(item.presType) >= 0 &&
              ["Local"].indexOf(item.meetingType) >= 0
          },
          {
            name: "Facilitator of Problem-Based Learning Discussion at Regional meeting",
            field: "presentations",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              ["PBLD Facilitator"].indexOf(item.presType) >= 0 &&
              ["Regional"].indexOf(item.meetingType) >= 0
          },
          {
            name: "Facilitator of Problem-Based Learning Discussion at National or International meeting",
            field: "presentations",
            value: "5",
            score: (list) => list.length * 5,
            filter: (item) =>
              ["PBLD Facilitator"].indexOf(item.presType) >= 0 &&
              ["National", "International"].indexOf(item.meetingType) >= 0
          },
          {
            name: "Workshop Instructor for a Local meeting",
            field: "presentations",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              ["Workshop"].indexOf(item.presType) >= 0 &&
              ["Local"].indexOf(item.meetingType) >= 0
          },
          {
            name: "Workshop Instructor for Regional meeting",
            field: "presentations",
            value: "2",
            score: (list) => list.length * 2,
            filter: (item) =>
              ["Workshop"].indexOf(item.presType) >= 0 &&
              ["Regional"].indexOf(item.meetingType) >= 0
          },
          {
            name: "Workshop Instructor for National or International meeting",
            field: "presentations",
            value: "4",
            score: (list) => list.length * 4,
            filter: (item) =>
              ["Workshop"].indexOf(item.presType) >= 0 &&
              ["National", "International"].indexOf(item.meetingType) >= 0
          },
          {
            name: "Panel Moderator for a Local meeting",
            field: "presentations",
            value: "0.5",
            score: (list) => list.length * 0.5,
            filter: (item) =>
              ["Panel Moderator"].indexOf(item.presType) >= 0 &&
              ["Local"].indexOf(item.meetingType) >= 0
          },
          {
            name: "Panel Moderator for a Regional meeting",
            field: "presentations",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              ["Panel Moderator"].indexOf(item.presType) >= 0 &&
              ["Regional"].indexOf(item.meetingType) >= 0
          },
          {
            name: "Panel Moderator for a National meeting",
            field: "presentations",
            value: "2",
            score: (list) => list.length * 2,
            filter: (item) =>
              ["Panel Moderator"].indexOf(item.presType) >= 0 &&
              ["National", "International"].indexOf(item.meetingType) >= 0
          }
        ]
      },
      {
        name: "Leadership: Education Related",
        list: [
          {
            name: "Course Director/Coordinator for a Local meeting",
            key: "education26",
            unit: "",
            value: "4",
            score: (num) => num * 4
          },
          {
            name: "Course Director/Coordinator for a Regional meeting",
            key: "education27",
            unit: "",
            value: "8",
            score: (num) => num * 8
          },
          {
            name: "Course Director/Coordinator or Program Chair for a National or International meeting",
            key: "education28",
            unit: "",
            value: "12",
            score: (num) => num * 12
          },
          {
            name: "Planning committee member for a Local meeting",
            key: "education29",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Planning committee member for a Regional meeting",
            key: "education30",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Planning committee member for a National or International meeting",
            key: "education31",
            unit: "",
            value: "4",
            score: (num) => num * 4
          },
          {
            name: "Workshop Coordinator for a Resident workshop",
            key: "education32",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Workshop Coordinator for a Local meeting",
            key: "education33",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Workshop Coordinator for a Regional meeting",
            key: "education34",
            unit: "",
            value: "4",
            score: (num) => num * 4
          },
          {
            name: "Workshop Coordinator for a National or International meeting",
            key: "education35",
            unit: "",
            value: "6",
            score: (num) => num * 6
          },
          {
            name: "Journal Club Organizer ",
            key: "education36",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Medical School Readiness Course Simulation Session Course Director",
            key: "education37",
            unit: "",
            value: "3",
            score: (num) => num * 3
          },
          {
            name: "Resident/Fellow Educational Course Leader (i.e. TEE, POCUS, preTCV, Education Day,  etc.)",
            key: "education38",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Mock Oral Exam Education Day Course Director",
            key: "education39",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Resident Mock Oral Examination Education Day Participant",
            key: "education40",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Resident mock APPLIED Course Director",
            key: "education41",
            unit: "",
            value: "4",
            score: (num) => num * 4
          },
          {
            name: "Mock APPLIED Exam Faculty Participant/Scorer/Leader",
            key: "education42",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Academy for Excellence in Education (New Member Inductee)",
            key: "education43",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Faculty Development Course Director ",
            key: "education44",
            unit: "",
            value: "3",
            score: (num) => num * 3
          },
          {
            name: "Faculty Development Course Facilitator",
            key: "education45",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Academy for Excellence in Education (Active Member)",
            key: "education46",
            unit: "",
            value: "0.5",
            score: (num) => num * 0.5
          }
        ]
      },
      {
        name: "Misc. Simulation Activities",
        list: [
          {
            name: "Resident/Fellow Simulation Session Facilitator",
            key: "education47",
            unit: "",
            value: "0.6",
            score: (num) => num * 0.6
          },
          {
            name: "Medical Student Anesthesiology Simulation Session Facilitator",
            key: "education48",
            unit: "",
            value: "0.6",
            score: (num) => num * 0.6
          },
          {
            name: "In-Situ Simulation Session, Facilitator",
            key: "education49",
            unit: "",
            value: "0.6",
            score: (num) => num * 0.6
          },
          {
            name: "In-Situ Simulation Session, Organizer - New Program",
            key: "education50",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "In-Situ Simulation Session, Organizer - Repeat Program",
            key: "education51",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Other Simulation activity leader",
            key: "education52",
            unit: "",
            value: "0.6",
            score: (num) => num * 0.6
          },
          {
            name: "Medical School Readinesw Course Simulation Session Facilitator",
            key: "education53",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "New Anesthesia Resident Foundations of Anesthesia Month (FAM) Simulation Session Faciltitator",
            key: "education54",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "New Anesthesia Resident FAM Simulation Session Organizer",
            key: "education55",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Fellowship Cadeaver Lab Facilitator",
            key: "education56",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "OSCE Scenario Author",
            key: "education57",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Skinny MOCA development/planning",
            key: "education58",
            unit: "",
            value: "4",
            score: (num) => num * 4
          },
          {
            name: "Skinny MOCA facilitator",
            key: "education59",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "New simulation session development ",
            key: "education60",
            unit: "",
            value: "3",
            score: (num) => num * 3
          }
        ]
      },
      {
        name: "Miscellaneous Education Related Activities",
        list: [
          {
            name: "Mock Oral Exam - Structured Format",
            key: "education61",
            unit: "",
            value: "0.3",
            score: (num) => num * 0.3
          },
          {
            name: "Educational Initiative Leader/Participant for medical providers outside of UVA ",
            key: "education62",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "FAM days",
            key: "education63",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "FAM lectures (NEW)",
            key: "education64",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "FAM lectures (REPEAT)",
            key: "education65",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Education Day (Main Session)",
            key: "education66",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Education Day (Lunch Session)",
            key: "education67",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Education Day (POCUS - removed PM)",
            key: "education68",
            unit: "",
            value: "0.3",
            score: (num) => num * 0.3
          },
          {
            name: "Education Day (Curriculum Development)",
            key: "education69",
            unit: "",
            value: "3",
            score: (num) => num * 3
          }
        ]
      },
      {
        name: "CME/Conference Attendance",
        list: [
          {
            name: "Journal Club Attendance",
            key: "education70",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Faculty Development Lecture Series Attendance (LAM)",
            key: "education71",
            unit: "",
            value: "0.8",
            score: (num) => num * 0.8
          },
          {
            name: "Faculty Development Lecture Series Attendance (Junior Faculty Development)",
            key: "education72",
            unit: "",
            value: "0.4",
            score: (num) => num * 0.4
          },
          {
            name: "Faculty Development Lecture Series Attendance (Mentoring/Mentee Program)",
            key: "education73",
            unit: "",
            value: "0.4",
            score: (num) => num * 0.4
          },
          {
            name: "Faculty Development Lecture Series Attendance (Other)",
            key: "education74",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "UVA Grand Rounds and MM&I (excluding morning faculty meetings) attendance",
            key: "education75",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "CME/CE Hours from Other Conference Attendance (outside UVA - i.e. SOAP, SEA, SAAAPM, ASA, ASRA, etc.) or other sources (i.e. onlie course)",
            key: "education76",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Non-CME/CE Educational Conference Attendance ",
            key: "education77",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          }
        ]
      },
      {
        name: "Other Activities",
        list: [
          {
            name: "Hours of Activity 1 (optional)",
            key: "education78",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 2 (optional)",
            key: "education79",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 3 (optional)",
            key: "education80",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 4 (optional)",
            key: "education81",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 5 (optional)",
            key: "education82",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          }
        ]
      }
    ]
  },
  {
    name: "Service and Admin",
    sections: [
      {
        name: "Mentorship/Letters of Recommendation",
        list: [
          {
            name: "Mentor to Medical Student",
            key: "service1",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "POD Leader for Residents",
            key: "service2",
            unit: "",
            value: "8",
            score: (num) => num * 8
          },
          {
            name: "Mentor for Resident/Fellow",
            key: "service3",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Mentor for Faculty",
            key: "service4",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Mentor to Graduate Student (Masters, PhD)",
            key: "service5",
            unit: "",
            value: "8",
            score: (num) => num * 8
          },
          {
            name: "Mentor to a Non-Physician Project (PhD Thesis advisor)",
            key: "service6",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Mentor to a Non-Physician Project (i.e. Other)",
            key: "service7",
            unit: "",
            value: "0.8",
            score: (num) => num * 0.8
          },
          {
            name: "Letter of Recommendation - for undergraduate student",
            key: "service8",
            unit: "",
            value: "0.4",
            score: (num) => num * 0.4
          },
          {
            name: "Letter of Recommendation - for medical student",
            key: "service9",
            unit: "",
            value: "0.4",
            score: (num) => num * 0.4
          },
          {
            name: "Letter of Recommendation - for resident/fellow",
            key: "service10",
            unit: "",
            value: "0.5",
            score: (num) => num * 0.5
          },
          {
            name: "Letter of Recommendation - for faculty promotion/FASA/Award, etc.",
            key: "service11",
            unit: "",
            value: "0.6",
            score: (num) => num * 0.6
          },
          {
            name: "External Reviewer for Faculty Promotion",
            key: "service12",
            unit: "",
            value: "0.6",
            score: (num) => num * 0.6
          }
        ]
      },
      {
        name: "Recruitment/Hosting",
        list: [
          {
            name: "Resident/Fellow Interviewer (per half day of interviews)",
            key: "service13",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Resident Recruitment Committee Prep & Review",
            key: "service14",
            unit: "",
            value: "6",
            score: (num) => num * 6
          },
          {
            name: "Fellowship Recruitment Committee Prep & Review",
            key: "service15",
            unit: "",
            value: "3",
            score: (num) => num * 3
          },
          {
            name: "Faculty Interview for Faculty Applicants",
            key: "service16",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Faculty Recruitment Dinner Host",
            key: "service17",
            unit: "",
            value: "0.5",
            score: (num) => num * 0.5
          },
          {
            name: "Faculty Recruitment Dinner Participant",
            key: "service18",
            unit: "",
            value: "0.4",
            score: (num) => num * 0.4
          }
        ]
      },
      {
        name: "Certification and Faculty Development",
        fields: ["certAndLic"],
        list: [
          {
            name: "PALS / ACLS / ATLS Certification Current",
            field: "clinicalActivityAndInnovations",
            section: "certAndLic",
            value: "1",
            score: (list) => list.length * 1,
            filter: (data) =>
              data.type == "certification" &&
              data.subType == "PALS / ACLS / ATLS"
          },
          {
            name: "PALS / ACLS / ATLS Instructor Certification Current",
            field: "clinicalActivityAndInnovations",
            section: "certAndLic",
            value: "2",
            score: (list) => list.length * 2,
            filter: (data) =>
              data.type == "certification" &&
              data.subType == "PALS / ACLS / ATLS Instructor"
          },
          {
            name: "ABA Primary Board Certificiation Obtained (points only awarded in year certification obtained)",
            field: "clinicalActivityAndInnovations",
            section: "certAndLic",
            value: "5",
            score: (list) => list.length * 5,
            filter: (data, { startDate, endDate }) => {
              return (
                data.type == "certification" &&
                data.subType == "Primary Board" &&
                isTimeWithinRange(
                  { start: data?.time?.start },
                  startDate,
                  endDate
                )
              );
            }
          },
          {
            name: "Subspecialty or Secondary Board Certification Obtained including Fellowship Board Certifications, Advanced TEE certification (points only awarded in year certification obtained)",
            field: "clinicalActivityAndInnovations",
            section: "certAndLic",
            value: "5",
            score: (list) => list.length * 5,
            filter: (data, { startDate, endDate }) => {
              return (
                data.type == "certification" &&
                ["Subspecialty Board", "Secondary Board"].indexOf(
                  data.subType
                ) >= 0 &&
                isTimeWithinRange(
                  { start: data?.time?.start },
                  startDate,
                  endDate
                )
              );
            }
          },
          {
            name: "Basic TEE certified (points only awarded in year certification obtained)",
            field: "clinicalActivityAndInnovations",
            section: "certAndLic",
            value: "3",
            score: (list) => list.length * 3,
            filter: (data, { startDate, endDate }) => {
              return (
                data.type == "certification" &&
                data.subType == "Basic TEE" &&
                isTimeWithinRange(
                  { start: data?.time?.start },
                  startDate,
                  endDate
                )
              );
            }
          },
          {
            name: "Active ABA MOCA Participant",
            field: "clinicalActivityAndInnovations",
            section: "certAndLic",
            value: "1",
            score: (list) => list.length * 1,
            filter: (data) =>
              data.type == "certification" &&
              data.subType == "ABA MOCA Participant"
          },
          {
            name: "FASA Designation (points only awarded in year certification obtained)",
            field: "clinicalActivityAndInnovations",
            section: "certAndLic",
            value: "1",
            score: (list) => list.length * 1,
            filter: (data, { startDate, endDate }) => {
              return (
                data.type == "certification" &&
                data.subType == "FASA" &&
                isTimeWithinRange(
                  { start: data?.time?.start },
                  startDate,
                  endDate
                )
              );
            }
          },
          {
            name: "Completion of other course certification (i.e. Advanced FATE Course, Instructor in Medical Simulation Course)",
            key: "service19",
            unit: "",
            value: "2",
            score: (num) => num * 2
          }
        ]
      },
      {
        name: "National/Regional/State Organization Service and Administration",
        fields: ["committeeService"],
        list: [
          {
            name: "ABA Oral Board Examiner",
            key: "service20",
            unit: "",
            value: "6",
            score: (num) => num * 6
          },
          {
            name: "Board, Credentialling or Maintenance of Certification Exam Question Writer (i.e. ITE, Basic/Advanced Exams, MOCA, Subspecialty MOCA, USMLE, COMLEX, Other Speciality Boards)",
            key: "service21",
            unit: "",
            value: "4",
            score: (num) => num * 4
          },
          {
            name: "Association of University Anesthesiologists (AUA) - New Member Inductee",
            key: "service22",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Non-Anesthesiology Specific National Committee, Member (i.e. AHA, ACC, ILCOR)",
            key: "service23",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Non-Anesthesiology Specific National Committee, Officer (i.e. treasurer, secretary, other)",
            key: "service24",
            unit: "",
            value: "3",
            score: (num) => num * 3
          },
          {
            name: "Non-Anesthesiology Specific National Committee, Chair/Vice-Chair ",
            key: "service25",
            unit: "",
            value: "6",
            score: (num) => num * 6
          },
          {
            name: "State Society Committee, Member",
            field: "committeeService",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              item.subType == "State Society Committee" &&
              item.membership == "Member"
          },
          {
            name: "State Society Committee, Officer (i.e. treasurer, secretary, other)",
            field: "committeeService",
            value: "4",
            score: (list) => list.length * 4,
            filter: (item) =>
              item.subType == "State Society Committee" &&
              item.membership == "Officer"
          },
          {
            name: "State Society Committee, Chair/Vice-Chair",
            field: "committeeService",
            value: "6",
            score: (list) => list.length * 6,
            filter: (item) =>
              item.subType == "State Society Committee" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "National Meeting Organizer - Chair/Co-Chair (i.e. anesthesia subspeciality meetings, CRC)",
            key: "service26",
            unit: "",
            value: "10",
            score: (num) => num * 10
          },
          {
            name: "Regional Meeting Organizer - Chair/Co-Chair (i.e. Meeting for attendees outside UVA in specific geographic region such as VSA)",
            key: "service27",
            unit: "",
            value: "7",
            score: (num) => num * 7
          },
          {
            name: "Local Meeting Organizer - Chair/Co-Chair (i.e. Meeting intended for UVA attendees)",
            key: "service28",
            unit: "",
            value: "4",
            score: (num) => num * 4
          },
          {
            name: "ASA / IARS / Subspecialty Committee, Member",
            field: "committeeService",
            value: "5",
            score: (list) => list.length * 5,
            filter: (item) =>
              item.subType == "ASA / IARS / Subspecialty Committee" &&
              item.membership == "Member"
          },
          {
            name: "ASA / IARS / Subspecialty Committee, Officer  (i.e. treasurer, secretary, other)",
            field: "committeeService",
            value: "7",
            score: (list) => list.length * 7,
            filter: (item) =>
              item.subType == "ASA / IARS / Subspecialty Committee" &&
              item.membership == "Officer"
          },
          {
            name: "ASA / IARS/ Subspecialty Committee, Chair/Vice-Chair",
            field: "committeeService",
            value: "10",
            score: (list) => list.length * 10,
            filter: (item) =>
              item.subType == "ASA / IARS / Subspecialty Committee" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "ABA / ACGME Review Committee, Member",
            field: "committeeService",
            value: "5",
            score: (list) => list.length * 5,
            filter: (item) =>
              item.subType == "ABA / ACGME Review Committee" &&
              item.membership == "Member"
          },
          {
            name: "ABA / ACGME Review Committee, Officer (i.e. treasurer, secretary, other)",
            field: "committeeService",
            value: "7",
            score: (list) => list.length * 7,
            filter: (item) =>
              item.subType == "ABA / ACGME Review Committee" &&
              item.membership == "Officer"
          },
          {
            name: "ABA / ACGME Review Committee, Chair/Vice-Chair",
            field: "committeeService",
            value: "10",
            score: (list) => list.length * 10,
            filter: (item) =>
              item.subType == "ABA / ACGME Review Committee" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "ASA Board of Directors Member (Director or Alternate Director)",
            key: "service29",
            unit: "",
            value: "5",
            score: (num) => num * 5
          },
          {
            name: "ASA Administrative Council/ASA Officer",
            key: "service30",
            unit: "",
            value: "20",
            score: (num) => num * 20
          },
          {
            name: "ABA / ABMS / ACGME / Medical Board Director",
            key: "service31",
            unit: "",
            value: "20",
            score: (num) => num * 20
          }
        ]
      },
      {
        name: "University/SOM/Hospital/UVA Health System Committee Service and Administration",
        list: [
          {
            name: "UVA Sponsored/Affiliated Community Service, Participant",
            key: "service32",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "UVA Sponsored/Affiliated Community Service, Coordinator (service that directly benefits the institution or hospital)",
            key: "service33",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Medical Director (i.e. PACU, TCVPO, NNICU, SICU, Pain Clinic, PETC) - Actvities seperate from Division Chief duties",
            key: "service34",
            unit: "",
            value: "6",
            score: (num) => num * 6
          },
          {
            name: "Departmental Division Chief",
            key: "service35",
            unit: "",
            value: "8",
            score: (num) => num * 8
          },
          {
            name: "PD (Residency)",
            key: "service36",
            unit: "",
            value: "20",
            score: (num) => num * 20
          },
          {
            name: "PD (Fellowship)",
            key: "service37",
            unit: "",
            value: "8",
            score: (num) => num * 8
          },
          {
            name: "APDs (Residency)?",
            key: "service38",
            unit: "",
            value: "10",
            score: (num) => num * 10
          },
          {
            name: "APDs (Fellowship)",
            key: "service39",
            unit: "",
            value: "4",
            score: (num) => num * 4
          },
          {
            name: "Board Runner (Main) - per shift",
            key: "service40",
            unit: "",
            value: "0.5",
            score: (num) => num * 0.5
          },
          {
            name: "Board Runner (OPSC1) - per shift",
            key: "service41",
            unit: "",
            value: "0.1",
            score: (num) => num * 0.1
          },
          {
            name: "New Clinical Service Initiation Efforts (such as setting up ambulatory surgery center practice, new speicality service requiring anestheisa services)",
            key: "service42",
            unit: "",
            value: "10",
            score: (num) => num * 10
          },
          {
            name: "SOM or UVA School of Medicine Promotion and Tenure Committee",
            key: "service43",
            unit: "",
            value: "10",
            score: (num) => num * 10
          },
          {
            name: "University's Provost Promotion and Tenure Committee",
            key: "service44",
            unit: "",
            value: "12",
            score: (num) => num * 12
          },
          {
            name: "SOM or UVA Health Committee, Chair/Vice-Chair",
            key: "service45",
            unit: "",
            value: "6",
            score: (num) => num * 6
          },
          {
            name: "SOM or UVA Health Ad-Hoc Committee, Member",
            key: "service46",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "SOM or UVA Health Ad-Hoc Committee, Chair/Vice-Chair",
            key: "service47",
            unit: "",
            value: "4",
            score: (num) => num * 4
          },
          {
            name: "UVA Health Committee, Member",
            key: "service48",
            unit: "",
            value: "4",
            score: (num) => num * 4
          },
          {
            name: "UVA Health Committee, Chair/Vice-Chair",
            key: "service49",
            unit: "",
            value: "8",
            score: (num) => num * 8
          },
          {
            name: "Departmental Representative for University/SOM/ Hospital Initiative, Project, or Accreditation visit (i.e. RRC, LCME)",
            key: "service50",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Attendance at UVA Non-Anesthesiology Specific Conference/Meeting (i.e. transplant selection conferences, RCA, etc.)",
            key: "service51",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          }
        ]
      },
      {
        name: "Departmental Committee Service and Administration",
        fields: ["committeeService"],
        list: [
          {
            name: "Clinical Competency Committee (Residency), Member",
            field: "committeeService",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "Residency Clinical Competency" &&
              item.membership == "Member"
          },
          {
            name: "Clinical Competency Committee (Residency), Chair/Vice-Chair",
            field: "committeeService",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              item.subType == "Residency Clinical Competency" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "Clinical Competency Committee (Fellowship), Member",
            field: "committeeService",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "Fellowship Clinical Competency" &&
              item.membership == "Member"
          },
          {
            name: "Clinical Competency Committee (Fellowship), Chair/Vice-Chair",
            field: "committeeService",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              item.subType == "Fellowship Clinical Competency" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "Capital Equipment Committee, Member",
            field: "committeeService",
            value: "0.5",
            score: (list) => list.length * 0.5,
            filter: (item) =>
              item.subType == "Capital Equipment" && item.membership == "Member"
          },
          {
            name: "Capital Equipment Committee, Chair/Vice-Chair",
            field: "committeeService",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "Capital Equipment" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "Clinical Care Advisory Committee, Member",
            field: "committeeService",
            value: "0.5",
            score: (list) => list.length * 0.5,
            filter: (item) =>
              item.subType == "Clinical Care Advisory" &&
              item.membership == "Member"
          },
          {
            name: "Clinical Care Advisory Committee, Chair/Vice-Chair",
            field: "committeeService",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "Clinical Care Advisory" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "Diversity, Equity, & Inclusion (DEI) Committee, Member",
            field: "committeeService",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "DEI" && item.membership == "Member"
          },
          {
            name: "Diversity, Equity, & Inclusion (DEI) Committee, Chair/Vice-Chair",
            field: "committeeService",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              item.subType == "DEI" && item.membership == "Chair / Vice Chair"
          },
          {
            name: "Compensation/Finance Committee, Member ",
            field: "committeeService",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "Compensation/Finance" &&
              item.membership == "Member"
          },
          {
            name: "Compensation/Finance Committee, Chair/Vice Chair",
            field: "committeeService",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              item.subType == "Compensation/Finance" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "Faculty Recruitment Committee, Chair/Vice Chair",
            field: "committeeService",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              item.subType == "Faculty Recruitment" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "EPIC & Systems Management Committee, Member",
            field: "committeeService",
            value: "0.5",
            score: (list) => list.length * 0.5,
            filter: (item) =>
              item.subType == "EPIC & Systems Management" &&
              item.membership == "Member"
          },
          {
            name: "EPIC & Systems Management Committee, Chair/Vice-Chair",
            field: "committeeService",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "EPIC & Systems Management" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "Medical Student Curriculum Committee, Member",
            field: "committeeService",
            value: "5",
            score: (list) => list.length * 5,
            filter: (item) =>
              item.subType == "Medical Student Curriculum" &&
              item.membership == "Member"
          },
          {
            name: "Medical Student Clerkship Committee, Chair/Vice-Chair",
            field: "committeeService",
            value: "5",
            score: (list) => list.length * 5,
            filter: (item) =>
              item.subType == "Medical Student Clerkship" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "Medical Student Admissions Committee, Member",
            field: "committeeService",
            value: "6",
            score: (list) => list.length * 6,
            filter: (item) =>
              item.subType == "Medical Student Admissions" &&
              item.membership == "Member"
          },
          {
            name: "Program Evaluation Committee (Residency), Member",
            field: "committeeService",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "Residency Program Evaluation" &&
              item.membership == "Member"
          },
          {
            name: "Program Evaluation Committee (Residency), Chair/Vice-Chair",
            field: "committeeService",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              item.subType == "Residency Program Evaluation" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "Program Evaluation Committee (Fellowship), Member",
            field: "committeeService",
            value: "0.5",
            score: (list) => list.length * 0.5,
            filter: (item) =>
              item.subType == "Fellowship Program Evaluation" &&
              item.membership == "Member"
          },
          {
            name: "Program Evaluation Committee (Fellowship), Chair/Vice-Chair",
            field: "committeeService",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "Fellowship Program Evaluation" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "Promotion and Tenure Committee, Member",
            field: "committeeService",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "Promotion and Tenure" &&
              item.membership == "Member"
          },
          {
            name: "P&T Committee, Chair/Vice-Chair",
            field: "committeeService",
            value: "4",
            score: (list) => list.length * 4,
            filter: (item) =>
              item.subType == "Promotion and Tenure" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "Research Committee, Member",
            field: "committeeService",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "Research" && item.membership == "Member"
          },
          {
            name: "Research Committee, Chair/Vice-Chair",
            field: "committeeService",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              item.subType == "Research" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "Resident/Fellow Recruitment Committee, Member",
            field: "committeeService",
            value: "6",
            score: (list) => list.length * 6,
            filter: (item) =>
              item.subType == "Resident / Fellow Recruitment" &&
              item.membership == "Member"
          },
          {
            name: "Communications Committee, Member",
            field: "committeeService",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "Communications" && item.membership == "Member"
          },
          {
            name: "Communications Committee, Chair/Vice-Chair",
            field: "committeeService",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              item.subType == "Communications" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "Academic Performance Assessment Committee, Member",
            field: "committeeService",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "Academic Performance Assessment" &&
              item.membership == "Member"
          },
          {
            name: "Academic Performance Assessment Committee, Chair/Vice-Chair",
            field: "committeeService",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              item.subType == "Academic Performance Assessment" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "Wellness Committee, Member",
            field: "committeeService",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "Wellness" && item.membership == "Member"
          },
          {
            name: "Wellness Committee, Chair/Vice-Chair",
            field: "committeeService",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              item.subType == "Wellness" &&
              item.membership == "Chair / Vice Chair"
          },
          {
            name: "Other Departmental Committee, Member",
            field: "committeeService",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "Other" && item.membership == "Member"
          },
          {
            name: "Other Departmental Committee, Chair",
            field: "committeeService",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              item.subType == "Other" && item.membership == "Chair / Vice Chair"
          }
        ]
      },
      {
        name: "Miscellaneous Activities",
        list: [
          {
            name: "Community Service Leader (Indicate number of hours)",
            key: "service52",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Leader for Miscellaneous Departmental Initiative or Project - (i.e. Update New Employee Handbook, ad hoc commitee)",
            key: "service53",
            unit: "",
            value: "0.6",
            score: (num) => num * 0.6
          },
          {
            name: "Non-Anesthesiology Departmental Adjunct Faculty Member (i.e. addiction medicine, surgery)",
            key: "service54",
            unit: "",
            value: "0.5",
            score: (num) => num * 0.5
          },
          {
            name: "Interview for press (i.e. news program, newspaper, magazine, etc.) (Indicate number of interviews)",
            key: "service55",
            unit: "",
            value: "0.5",
            score: (num) => num * 0.5
          },
          {
            name: "Attendance at Clinical Division Meeting, Retreat, Other clinical service meeting (i.e. LVAD conference) ",
            key: "service56",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Local or Regional Award (i.e. UVA, SOM, NCMB, etc.)",
            key: "service57",
            unit: "",
            value: "0.5",
            score: (num) => num * 0.5
          },
          {
            name: "National Award (i.e. lifetime achievement award from an organization)",
            key: "service58",
            unit: "",
            value: "5",
            score: (num) => num * 5
          },
          {
            name: "Member of Miscellaneous non-departmental review process (i.e chair review, hospital project, etc.)",
            key: "service59",
            unit: "",
            value: "0.5",
            score: (num) => num * 0.5
          },
          {
            name: "Member of a non-anesthesiology chair search committee",
            key: "service60",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "Administrative duty of the department not accounted for elsewhere (i.e. schedule making for a division done by a non-division chief member)",
            key: "service61",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Leadership Development Course Non-CME (i.e. UVA Faculty Development Courses)",
            key: "service62",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Leadership Development Course Leader Non-CME (i.e. UVA Faculty Development Courses)",
            key: "service63",
            unit: "",
            value: "0.3",
            score: (num) => num * 0.3
          },
          {
            name: "Educational Coursework Related to Departmental Work FUVAtions (ex. Graduate level courses)",
            key: "service64",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Medical Mission Trip (all clinical and educational work included)",
            key: "service65",
            unit: "",
            value: "5",
            score: (num) => num * 5
          },
          {
            name: "Anesthesiology Professional Advocacy Effort (i.e. meeting with lobbyists or politicians to advocate for the profession)",
            key: "service66",
            unit: "",
            value: "0.2",
            score: (num) => num * 0.2
          }
        ]
      },
      {
        name: "Other Activities",
        list: [
          {
            name: "Hours of Activity 1 (optional)",
            key: "service67",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 2 (optional)",
            key: "service68",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 3 (optional)",
            key: "service69",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 4 (optional)",
            key: "service70",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 5 (optional)",
            key: "service71",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          }
        ]
      }
    ]
  },
  {
    name: "QI",
    sections: [
      {
        name: "Mentorship: QI Related",
        list: [
          {
            name: "Mentor to Medical Student as part of a Quality Improvement Project",
            key: "qi1",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Mentor to Residents as part of Team-Based Quality Improvement Project",
            key: "qi2",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Mentor to Fellow as part of Quality Improvement Project",
            key: "qi3",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Mentor to Resident as part of a QI project (department/other department/SOM)",
            key: "qi4",
            unit: "",
            value: "1",
            score: (num) => num * 1
          }
        ]
      },
      {
        name: "QI Project Leadership/Participation",
        list: [
          {
            name: "Clinical Pathway (i.e. Enhanced Recovery Pathway, Code Stroke, etc.) - Development team member",
            key: "qi5",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Clinical Pathway (i.e. Enhanced Recovery Pathway, Code Stroke, etc.) - Anesthesia lead for Pathway (Existing Pathway)",
            key: "qi6",
            unit: "",
            value: "3",
            score: (num) => num * 3
          },
          {
            name: "Clinical Pathway (i.e. Enhanced Recovery Pathway, Code Stroke, etc) - Anesthesia lead for Pathway (New Pathway Developed)",
            key: "qi7",
            unit: "",
            value: "5",
            score: (num) => num * 5
          },
          {
            name: "UVA Hospitals/SOM/Department of Anesthesiology - Quality Improvement  Be Safe Anesthesia Physician Participant",
            key: "qi8",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "UVA Hospitals/SOM/Department of Anesthesiology - Quality Improvement & Be Safe Anesthesia Physician Leader",
            key: "qi9",
            unit: "",
            value: "12",
            score: (num) => num * 12
          },
          {
            name: "UVA Hospitals/SOM Quality Improvement & Be Safe related to an organizational quality goal - Anesthesia Participant",
            key: "qi10",
            unit: "",
            value: "2",
            score: (num) => num * 2
          },
          {
            name: "UVA Hospitals/SOM Quality Improvement & Be Safe related to an organizational quality goal - Anesthesia Lead",
            key: "qi11",
            unit: "",
            value: "4",
            score: (num) => num * 4
          },
          {
            name: "Principal Investigator (PI) for large multi-center or externally funded (e.g. APSF, ARHQ, MPOG) QI project",
            key: "qi12",
            unit: "",
            value: "8",
            score: (num) => num * 8
          },
          {
            name: "Co-principal investigator (Co-PI) for  large multi-center or externally funded (e.g. APSF, ARHQ, MPOG) QI project",
            key: "qi13",
            unit: "",
            value: "4",
            score: (num) => num * 4
          },
          {
            name: "Departmental/Interdepartmental small-scale QI project (Epic changes, templates, new resource, tools, etc) - Participant",
            key: "qi14",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Departmental/Interdepartmental small-scale QI project (Epic changes, templates, new resource, tools, etc) - Physician Lead",
            key: "qi15",
            unit: "",
            value: "2",
            score: (num) => num * 2
          }
        ]
      },
      {
        name: "Presentations: QI Related",
        fields: ["scholarship"],
        list: [
          {
            name: "Morbidity, Mortality, and Improvement (MM&I) Conference - Moderator (indicate the number of sessions)",
            key: "qi16",
            unit: "",
            value: "1",
            score: (num) => num * 1
          },
          {
            name: "Morbidity, Mortality, and Improvement (MM&I) Conference - Program Coordinator",
            key: "qi17",
            unit: "",
            value: "5",
            score: (num) => num * 5
          },
          {
            name: "Abstract/Poster Presentation at Local Quality Improvement (first/last author)",
            field: "scholarship",
            value: "0.2",
            score: (list) => list.length * 0.2,
            filter: (item) =>
              item.type == "abstracts" &&
              item.subType == "Local QI Conference" &&
              ["First", "Last"].indexOf(item.authorPlace) >= 0
          },
          {
            name: "Abstract/Poster Presentation at Local Quality Improvement (middle author)",
            field: "scholarship",
            value: "0.1",
            score: (list) => list.length * 0.1,
            filter: (item) =>
              item.type == "abstracts" &&
              item.subType == "Local QI Conference" &&
              ["Middle"].indexOf(item.authorPlace) >= 0
          },
          {
            name: "Abstract/Poster Presentation at Regional Quality Improvement Conference (first/last author)",
            field: "scholarship",
            value: "0.5",
            score: (list) => list.length * 0.5,
            filter: (item) =>
              item.type == "abstracts" &&
              item.subType == "Regional QI Conference" &&
              ["First", "Last"].indexOf(item.authorPlace) >= 0
          },
          {
            name: "Abstract/Poster Presentation at Regional Quality Improvement Conference (middle author)",
            field: "scholarship",
            value: "0.2",
            score: (list) => list.length * 0.2,
            filter: (item) =>
              item.type == "abstracts" &&
              item.subType == "Regional QI Conference" &&
              ["Middle"].indexOf(item.authorPlace) >= 0
          },
          {
            name: "Abstract/Poster Presentation at National Quality Improvement Conference (first/last author)",
            field: "scholarship",
            value: "2",
            score: (list) => list.length * 2,
            filter: (item) =>
              item.type == "abstracts" &&
              item.subType == "National QI Conference" &&
              ["First", "Last"].indexOf(item.authorPlace) >= 0
          },
          {
            name: "Abstract/Poster Presentation at National Quality Improvement Conference (middle author)",
            field: "scholarship",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.type == "abstracts" &&
              item.subType == "National QI Conference" &&
              ["Middle"].indexOf(item.authorPlace) >= 0
          }
        ]
      },
      {
        name: "Grants: QI Related",
        fields: ["projects"],
        list: [
          {
            name: "Submitted (pending/not awarded) QI project for a local patient safety/quality improvement grant (ie. seed grant)",
            field: "projects",
            value: "1.5",
            score: (list) => list.length * 1.5,
            filter: (item) =>
              ["State", "Other"].indexOf(item.sourceType) >= 0 &&
              !!item.qi &&
              !!item.pending
          },
          {
            name: "Awarded a local patient safety/quality improvement grant (ie. seed grant)",
            field: "projects",
            value: "6",
            score: (list) => list.length * 6,
            filter: (item) =>
              ["State", "Other"].indexOf(item.sourceType) >= 0 &&
              !!item.qi &&
              !item.pending
          },
          {
            name: "Submitted (pending/not awarded) QI project  for a national patient safety quality improvement grant (ie. APSF grant)",
            field: "projects",
            value: "2.5",
            score: (list) => list.length * 2.5,
            filter: (item) =>
              ["Federal"].indexOf(item.sourceType) >= 0 &&
              !!item.qi &&
              !!item.pending
          },
          {
            name: "Awarded a QI project for a national patient safety quality improvement grant (ie. APSF grant)",
            field: "projects",
            value: "8",
            score: (list) => list.length * 8,
            filter: (item) =>
              ["Federal"].indexOf(item.sourceType) >= 0 &&
              !!item.qi &&
              !item.pending
          }
        ]
      },
      {
        name: "Other Activities",
        list: [
          {
            name: "Hours of Activity 1 (optional)",
            key: "qi18",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 2 (optional)",
            key: "qi19",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 3 (optional)",
            key: "qi20",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 4 (optional)",
            key: "qi21",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 5 (optional)",
            key: "qi22",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          }
        ]
      }
    ]
  },
  {
    name: "Research Items",
    sections: [
      {
        name: "Publications/Manuscripts/Books",
        fields: ["scholarship"],
        list: [
          {
            name: "Publication of Original Research or Systematic Review in a Peer-reviewed Pubmed Indexed Journal (First or Last/Senior Author)",
            field: "scholarship",
            value: "5 + (Impact Factor x 2)",
            score: (list) =>
              list
                .map((n) => {
                  return n.impact == null || isNaN(parseFloat(n.impact))
                    ? null
                    : parseFloat(n.impact);
                })
                .filter((n) => n != null)
                .map((n) => 5 + n * 2)
                .reduce((a, b) => a + b, 0),
            filter: (item) =>
              ["First", "Last"].indexOf(item.authorPlace) >= 0 &&
              item.type == "Research Investigations" &&
              ["Original Research", "Systematic Review"].indexOf(
                item.subType
              ) >= 0 &&
              (item.PMID || "").trim().length > 0
          },
          {
            name: "Publication of Original Research or Systematic Review in a Peer-reviewed Pubmed Indexed Journal (Middle Author)",
            field: "scholarship",
            value: "5",
            score: (list) => list.length * 5,
            filter: (item) =>
              item.authorPlace == "Middle" &&
              item.type == "Research Investigations" &&
              ["Original Research", "Systematic Review"].indexOf(
                item.subType
              ) >= 0 &&
              (item.PMID || "").trim().length > 0
          },

          {
            name: "Publication of Original Research or Systematic Review in a Peer-reviewed Non-Pubmed Indexed Journal (First or Senior Author)",
            field: "scholarship",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              ["First", "Last"].indexOf(item.authorPlace) >= 0 &&
              item.type == "Research Investigations" &&
              ["Original Research", "Systematic Review"].indexOf(
                item.subType
              ) >= 0 &&
              (item.PMID || "").trim().length == 0
          },
          {
            name: "Publication of Original Research or Systematic Review in a Peer-reviewed Non-Pubmed Indexed Journal (Middle Author)",
            field: "scholarship",
            value: "2",
            score: (list) => list.length * 2,
            filter: (item) =>
              item.authorPlace == "Middle" &&
              item.type == "Research Investigations" &&
              ["Original Research", "Systematic Review"].indexOf(
                item.subType
              ) >= 0 &&
              (item.PMID || "").trim().length == 0
          },

          {
            name: "Publication of a Narrative Review Article in a Peer-reviewed Pubmed Indexed Journal (First or Senior Author)",
            field: "scholarship",
            value: "5 + (Impact Factor x 1.5)",
            score: (list) =>
              list
                .map((n) => {
                  return n.impact == null || isNaN(parseFloat(n.impact))
                    ? null
                    : parseFloat(n.impact);
                })
                .filter((n) => n != null)
                .map((n) => 5 + n * 1.5)
                .reduce((a, b) => a + b, 0),
            filter: (item) =>
              ["First", "Last"].indexOf(item.authorPlace) >= 0 &&
              item.type == "Research Investigations" &&
              ["Narrative Review Article"].indexOf(item.subType) >= 0 &&
              (item.PMID || "").trim().length > 0
          },
          {
            name: "Publication of a Narrative Review Article in a Peer-reviewed Pubmed Indexed Journal (Middle Author)",
            field: "scholarship",
            value: "4",
            score: (list) => list.length * 4,
            filter: (item) =>
              ["Middle"].indexOf(item.authorPlace) >= 0 &&
              item.type == "Research Investigations" &&
              ["Narrative Review Article"].indexOf(item.subType) >= 0 &&
              (item.PMID || "").trim().length > 0
          },
          {
            name: "Publication of a Narrative Review Article in a Peer-reviewed Non-Pubmed Indexed Journal (First or Senior Author)",
            field: "scholarship",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              ["First", "Last"].indexOf(item.authorPlace) >= 0 &&
              item.type == "Research Investigations" &&
              ["Narrative Review Article"].indexOf(item.subType) >= 0 &&
              (item.PMID || "").trim().length == 0
          },
          {
            name: "Publication of a Narrative Review Article in a Peer-reviewed Non-Pubmed Indexed Journal (Middle Author)",
            field: "scholarship",
            value: "2",
            score: (list) => list.length * 2,
            filter: (item) =>
              ["Middle"].indexOf(item.authorPlace) >= 0 &&
              item.type == "Research Investigations" &&
              ["Narrative Review Article"].indexOf(item.subType) >= 0 &&
              (item.PMID || "").trim().length == 0
          },

          {
            name: "Publication of a case report or editorial in a Peer-reviewed Pubmed Indexed Journal (First or Senior Author)",
            field: "scholarship",
            value: "2",
            score: (list) => list.length * 2,
            filter: (item) =>
              ["First", "Last"].indexOf(item.authorPlace) >= 0 &&
              item.type == "Research Investigations" &&
              ["Case Report", "Editorial"].indexOf(item.subType) >= 0 &&
              (item.PMID || "").trim().length > 0
          },
          {
            name: "Publication of a case report or editorial in a Peer-reviewed Pubmed Indexed Journal (Middle Author)",
            field: "scholarship",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              ["Middle"].indexOf(item.authorPlace) >= 0 &&
              item.type == "Research Investigations" &&
              ["Case Report", "Editorial"].indexOf(item.subType) >= 0 &&
              (item.PMID || "").trim().length > 0
          },
          {
            name: "Publication of a case report or editorial in a Peer-reviewed Non-Pubmed Indexed Journal (First or Senior Author)",
            field: "scholarship",
            value: "2",
            score: (list) => list.length * 2,
            filter: (item) =>
              ["First", "Last"].indexOf(item.authorPlace) >= 0 &&
              item.type == "Research Investigations" &&
              ["Case Report", "Editorial"].indexOf(item.subType) >= 0 &&
              (item.PMID || "").trim().length == 0
          },
          {
            name: "Publication of a case report or editorial in a Peer-reviewed Non-Pubmed Indexed Journal (Middle Author)",
            field: "scholarship",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              ["Middle"].indexOf(item.authorPlace) >= 0 &&
              item.type == "Research Investigations" &&
              ["Case Report", "Editorial"].indexOf(item.subType) >= 0 &&
              (item.PMID || "").trim().length == 0
          },

          {
            name: "Publication of an invited commentaries, letters to the editor, etc. in a Peer-reviewed Pubmed Indexed Journal (Any Author)",
            field: "scholarship",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.type == "Research Investigations" &&
              ["Invited Commentary", "Letter to the Editor"].indexOf(
                item.subType
              ) >= 0 &&
              (item.PMID || "").trim().length > 0
          },
          {
            name: "Publication of a Non-Peer-reviewed, Non-Pubmed Indexed Article (e.g. Anesthesiology News, ASA Monitor, VSA newsletter, Audio Digest, Website)",
            field: "scholarship",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.type == "Research Investigations" &&
              ["Narrative Review Article"].indexOf(item.subType) >= 0 &&
              (item.PMID || "").trim().length == 0
          },
          {
            name: "Self-Publication of Digital Educational Content (i.e. podcast, YouTube training video)",
            field: "scholarship",
            value: "0.5",
            score: (list) => list.length * 0.5,
            filter: (item) => item.type == "nonprint"
          },
          {
            name: "Book Chapter Publication (New Chapter/Any Author position, Long chapter - greater than 4000 words)",
            field: "scholarship",
            value: "8",
            score: (list) => list.length * 8,
            filter: (item) =>
              item.type == "chapters" &&
              ["Long Chapter (> 4000 words)"].indexOf(item.chapterType) >= 0
          },
          {
            name: "Book Chapter Publication (New Chapter/Any Author position, Short chapter - less than 4000 words)",
            field: "scholarship",
            value: "4",
            score: (list) => list.length * 4,
            filter: (item) =>
              item.type == "chapters" &&
              ["Short Chapter (< 4000 words)"].indexOf(item.chapterType) >= 0
          }
        ]
      },
      {
        name: "Presentations",
        fields: ["presentations"],
        list: [
          {
            name: "Oral Podium / Platform Presentation of an Abstract at National, Subspecialty or International Meeting (First/last author or primary mentor to trainee)",
            field: "presentations",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item) =>
              ["Platform"].includes(item.presType) &&
              ["National", "Subspecialty", "International"].includes(
                item.meetingType
              ) &&
              ["First", "Last", "Primary Mentor to Trainee"].includes(
                item.authorPlace
              )
          },
          {
            name: "Oral Podium / Platform Presentation of an Abstract at National, Subspecialty or International Meeting (Middle author)",
            field: "presentations",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              ["Platform"].includes(item.presType) &&
              ["National", "Subspecialty", "International"].includes(
                item.meetingType
              ) &&
              ["Middle"].includes(item.authorPlace)
          },

          {
            name: "Oral Podium / Platform Presentation of an Abstract at Regional Meeting (First/last author or primary mentor to trainee)",
            field: "presentations",
            value: "2",
            score: (list) => list.length * 2,
            filter: (item) =>
              ["Platform"].includes(item.presType) &&
              ["Regional"].includes(item.meetingType) &&
              ["First", "Last", "Primary Mentor to Trainee"].includes(
                item.authorPlace
              )
          },
          {
            name: "Oral Podium / Platform Presentation of an Abstract at Regional Meeting (middle author)",
            field: "presentations",
            value: "0.5",
            score: (list) => list.length * 0.5,
            filter: (item) =>
              ["Platform"].includes(item.presType) &&
              ["Regional"].includes(item.meetingType) &&
              ["Middle"].includes(item.authorPlace)
          },

          {
            name: "Oral Podium / Platform Presentation of an Abstract at Local Meeting (First/last author or primary mentor to trainee)",
            field: "presentations",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              ["Platform"].includes(item.presType) &&
              ["Local"].includes(item.meetingType) &&
              ["First", "Last", "Primary Mentor to Trainee"].includes(
                item.authorPlace
              )
          },
          {
            name: "Oral Podium / Platform Presentation of an Abstract at Local Meeting (middle author)",
            field: "presentations",
            value: "0.25",
            score: (list) => list.length * 0.25,
            filter: (item) =>
              ["Platform"].includes(item.presType) &&
              ["Local"].includes(item.meetingType) &&
              ["Middle"].includes(item.authorPlace)
          },

          {
            name: "Poster Presentation (or equivalent) at National, Subspecialty or International Meeting (First/last author or primary mentor to trainee)", //
            field: "presentations",
            value: "2",
            score: (list) => list.length * 2,
            filter: (item) =>
              ["Poster"].includes(item.presType) &&
              ["National", "Subspecialty", "International"].includes(
                item.meetingType
              ) &&
              ["First", "Last", "Primary Mentor to Trainee"].includes(
                item.authorPlace
              )
          },
          {
            name: "Poster Presentation (or equivalent) at National, Subspecialty or International Meeting (Middle author)",
            field: "presentations",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              ["Poster"].includes(item.presType) &&
              ["National", "Subspecialty", "International"].includes(
                item.meetingType
              ) &&
              ["Middle"].includes(item.authorPlace)
          },

          {
            name: "Poster Presentation (or equivalent) at a Regional Meeting  (First/last author or primary mentor to trainee)",
            field: "presentations",
            value: "0.5",
            score: (list) => list.length * 0.5,
            filter: (item) =>
              ["Poster"].includes(item.presType) &&
              ["Regional"].includes(item.meetingType) &&
              ["First", "Last", "Primary Mentor to Trainee"].includes(
                item.authorPlace
              )
          },
          {
            name: "Poster Presentation (or equivalent) at a Regional Meeting  (middle author)",
            field: "presentations",
            value: "0.2",
            score: (list) => list.length * 0.2,
            filter: (item) =>
              ["Poster"].includes(item.presType) &&
              ["Regional"].includes(item.meetingType) &&
              ["Middle"].includes(item.authorPlace)
          },

          {
            name: "Poster Presentation (or equivalent) at a Local Meeting (First/last author or primary mentor to trainee) - Day of Research",
            field: "presentations",
            value: "0.5",
            score: (list) => list.length * 0.5,
            filter: (item) =>
              ["Poster"].includes(item.presType) &&
              ["Local"].includes(item.meetingType) &&
              ["First", "Last", "Primary Mentor to Trainee"].includes(
                item.authorPlace
              )
          },
          {
            name: "Poster Presentation (or equivalent) at a Local Meeting (middle author)",
            field: "presentations",
            value: "0.2",
            score: (list) => list.length * 0.2,
            filter: (item) =>
              ["Poster"].includes(item.presType) &&
              ["Local"].includes(item.meetingType) &&
              ["Middle"].includes(item.authorPlace)
          }
        ]
      },
      {
        name: "Grants: Research Related",
        fields: ["projects"],
        list: [
          {
            name: "Research Grant - PI and multi-PI, credit given if ongoing (NIH R01 or K grant or equivalent)",
            field: "projects",
            value: "25",
            score: (list) => list.length * 25,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isMentor = role.indexOf("mentor") >= 0;
              return (
                isMentor &&
                ["NIH R01 or K or equivalent"].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Research Grant - PI Mentor,  credit given if ongoing (NIH R01 or K grant or equivalent)",
            field: "projects",
            value: "8.25",
            score: (list) => list.length * 8.25,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isMentor = role.indexOf("mentor") >= 0;
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !isMentor &&
                !isCo &&
                isPi &&
                ["NIH R01 or K or equivalent"].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Research 2Grant - Co-I, credit given if ongoing (NIH R01 or K grant or equivalent)",
            field: "projects",
            value: "10",
            score: (list) => list.length * 10,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isMentor = role.indexOf("mentor") >= 0;
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !isMentor &&
                isCo &&
                isPi &&
                ["NIH R01 or K or equivalent"].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Research Grant -  PI and multi-PI, credit given if ongoing (NIH R21 or equivalent)",
            field: "projects",
            value: "20",
            score: (list) => list.length * 20,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !isCo &&
                isPi &&
                ["NIH R21 or equivalent"].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Research Grant - CO-I and multi-PI, credit given if ongoing (NIH R21 or equivalent)",
            field: "projects",
            value: "8",
            score: (list) => list.length * 8,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                isCo &&
                isPi &&
                ["NIH R21 or equivalent"].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Research Grant - PI and multi-PI, credit given if ongoing (Foundation or Society or equivalent e.g., FAER)",
            field: "projects",
            value: "16",
            score: (list) => list.length * 16,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isMentor = role.indexOf("mentor") >= 0;
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !isMentor &&
                !isCo &&
                isPi &&
                ["Foundation or Society or equivalent"].indexOf(
                  item.grantType
                ) >= 0
              );
            }
          },
          {
            name: "Research Grant - PI and multi-PI Mentor, credit given if ongoing (Foundation or Society or equivalent e.g., FAER)",
            field: "projects",
            value: "5.25",
            score: (list) => list.length * 5.25,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isMentor = role.indexOf("mentor") >= 0;
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                isMentor &&
                ["Foundation or Society or equivalent"].indexOf(
                  item.grantType
                ) >= 0
              );
            }
          },
          {
            name: "Research Grant - Co-I, credit given if ongoing (Foundation or Society or equivalent e.g., FAER)",
            field: "projects",
            value: "6.4",
            score: (list) => list.length * 6.4,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isMentor = role.indexOf("mentor") >= 0;
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !isMentor &&
                isCo &&
                isPi &&
                ["Foundation or Society or equivalent"].indexOf(
                  item.grantType
                ) >= 0
              );
            }
          },
          {
            name: "Research Grant - PI and multi-PI, credit given if ongoing (Institutional grant e.g. IBM Career Junior Faculty Development Award)",
            field: "projects",
            value: "8",
            score: (list) => list.length * 8,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !isCo && isPi && ["Institutional"].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Research Grant - Co-I, credit given if ongoing (Institutional grant e.g. IBM Career Junior Faculty Development Award)",
            field: "projects",
            value: "3.2",
            score: (list) => list.length * 3.2,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !!isCo && isPi && ["Institutional"].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Submission of Federal Research Grant - PI and multi-PI",
            field: "projects",
            value: "12.5",
            score: (list) => list.length * 12.5,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !isCo &&
                isPi &&
                ["Submission of Federal Research Grant"].indexOf(
                  item.grantType
                ) >= 0
              );
            }
          },
          {
            name: "Submission of Federal Research Grant - Co-I ",
            field: "projects",
            value: "5",
            score: (list) => list.length * 5,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !!isCo &&
                isPi &&
                ["Submission of Federal Research Grant"].indexOf(
                  item.grantType
                ) >= 0
              );
            }
          },
          {
            name: "Submission of Foundation or Society or equivalent grant - PI and multi-PI",
            field: "projects",
            value: "4",
            score: (list) => list.length * 4,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !isCo &&
                isPi &&
                ["Submission of Foundation or Society or equivalent"].indexOf(
                  item.grantType
                ) >= 0
              );
            }
          },
          {
            name: "Submission of Foundation or Society or equivalent grant - Co-I",
            field: "projects",
            value: "1.5",
            score: (list) => list.length * 1.5,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !!isCo &&
                isPi &&
                ["Submission of Foundation or Society or equivalent"].indexOf(
                  item.grantType
                ) >= 0
              );
            }
          },
          {
            name: "Submission of Insitutional Grant - PI and multi-PI",
            field: "projects",
            value: "2.5",
            score: (list) => list.length * 2.5,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !isCo &&
                isPi &&
                ["Submission of Insitutional Grant"].indexOf(item.grantType) >=
                  0
              );
            }
          },
          {
            name: "Submission of Insitutional Grant - Co-I",
            field: "projects",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !!isCo &&
                isPi &&
                ["Submission of Insitutional Grant"].indexOf(item.grantType) >=
                  0
              );
            }
          },
          {
            name: "Research Grant - Industry Sponsored - PI and multi-PI",
            field: "projects",
            value: "5",
            score: (list) => list.length * 5,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !isCo &&
                isPi &&
                ["Industry Sponsored Grant"].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Research Grant - Industry Sponsored - Co-I",
            field: "projects",
            value: "2",
            score: (list) => list.length * 2,
            filter: (item) => {
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !!isCo &&
                isPi &&
                ["Industry Sponsored Grant"].indexOf(item.grantType) >= 0
              );
            }
          }
        ]
      },
      {
        name: "Research Trial / Project Participation",
        fields: ["projects"],
        list: [
          {
            name: "Intitiation of Multi-Center Clinical Trial - National PI",
            field: "projects",
            value: "20",
            score: (list) => list.length * 20,
            filter: (item, { startDate, endDate }) => {
              var startDuring = isTimeWithinRange(
                { start: item.time.start },
                startDate,
                endDate
              );
              var role = (item.role || "").toLowerCase();
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                startDuring &&
                isPi &&
                role.indexOf("national") >= 0 &&
                ["Multi-Center Clinical Trial"].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Intitiation of Clinical Trial - Institutional PI or site PI",
            field: "projects",
            value: "10",
            score: (list) => list.length * 10,
            filter: (item, { startDate, endDate }) => {
              var startDuring = isTimeWithinRange(
                { start: item.time.start },
                startDate,
                endDate
              );
              var role = (item.role || "").toLowerCase();
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                startDuring &&
                isPi &&
                role.indexOf("national") == -1 &&
                [
                  "Multi-Center Clinical Trial",
                  "Single-Center Clinical Trial"
                ].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Inititiation of Other Grant Supported Research Trial PI",
            field: "projects",
            value: "10",
            score: (list) => list.length * 10,
            filter: (item, { startDate, endDate }) => {
              var startDuring = isTimeWithinRange(
                { start: item.time.start },
                startDate,
                endDate
              );
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                startDuring &&
                isPi &&
                !isCo &&
                ["Other Grant Support"].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Inititiation of Other Grant Supported Research Trial (Co-I)",
            field: "projects",
            value: "3",
            score: (list) => list.length * 3,
            filter: (item, { startDate, endDate }) => {
              var startDuring = isTimeWithinRange(
                { start: item.time.start },
                startDate,
                endDate
              );
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                startDuring &&
                isPi &&
                !!isCo &&
                ["Other Grant Support"].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Ongoing Multi-Center Clinical Trial - National PI",
            field: "projects",
            value: "10",
            score: (list) => list.length * 10,
            filter: (item, { startDate, endDate }) => {
              var startDuring = isTimeWithinRange(
                { start: item.time.start },
                startDate,
                endDate
              );
              var role = (item.role || "").toLowerCase();
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !startDuring &&
                isPi &&
                role.indexOf("national") >= 0 &&
                ["Multi-Center Clinical Trial"].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Ongoing Clinical Trial - Institutional PI or site PI",
            field: "projects",
            value: "5",
            score: (list) => list.length * 5,
            filter: (item, { startDate, endDate }) => {
              var startDuring = isTimeWithinRange(
                { start: item.time.start },
                startDate,
                endDate
              );
              var role = (item.role || "").toLowerCase();
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !startDuring &&
                isPi &&
                role.indexOf("national") == -1 &&
                [
                  "Multi-Center Clinical Trial",
                  "Single-Center Clinical Trial"
                ].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Ongoing Other Grant Supported Research Trial PI",
            field: "projects",
            value: "5",
            score: (list) => list.length * 5,
            filter: (item, { startDate, endDate }) => {
              var startDuring = isTimeWithinRange(
                { start: item.time.start },
                startDate,
                endDate
              );
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !startDuring &&
                isPi &&
                !isCo &&
                ["Other Grant Support"].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Ongoing Other Grant Supported Research Trial (Co-I)",
            field: "projects",
            value: "1.5",
            score: (list) => list.length * 1.5,
            filter: (item, { startDate, endDate }) => {
              var startDuring = isTimeWithinRange(
                { start: item.time.start },
                startDate,
                endDate
              );
              var role = (item.role || "").toLowerCase();
              var isCo = ["co"].some((key) => role.indexOf(key) >= 0);
              var isPi = ["pi", "investigator"].some(
                (key) => role.indexOf(key) >= 0
              );
              return (
                !startDuring &&
                isPi &&
                !!isCo &&
                ["Other Grant Support"].indexOf(item.grantType) >= 0
              );
            }
          },
          {
            name: "Presentation of full research proposal/budget to departmental research committee",
            field: "projects",
            value: "0.5",
            score: (list) => list.length * 0.5,
            filter: (item) => {
              return (
                ["Proposal Presentated to Research Committee"].indexOf(
                  item.grantType
                ) >= 0
              );
            }
          },
          {
            name: "Ongoing Research Committee supported project",
            field: "projects",
            value: "0.5",
            score: (list) => list.length * 0.5,
            filter: (item) => {
              return (
                ["Research Committee Support"].indexOf(item.grantType) >= 0
              );
            }
          }
        ]
      },
      {
        name: "Editor/Reviewer",
        fields: ["editorialActivities"],
        list: [
          {
            name: "Book Editor",
            field: "editorialActivities",
            value: "6",
            score: (list) => list.length * 6,
            filter: (item) => item.editorType == "Book Editor"
          },
          {
            name: "Journal: Non-Open Access (Section Editor)",
            field: "editorialActivities",
            value: "20",
            score: (list) => list.length * 20,
            filter: (item) =>
              item.editorType == "Journal: Non-Open Access (Section Editor)"
          },
          {
            name: "Journal: Non-Open Access (Associate/Deputy Editor)",
            field: "editorialActivities",
            value: "12",
            score: (list) => list.length * 12,
            filter: (item) =>
              item.editorType ==
              "Journal: Non-Open Access (Associate/Deputy Editor)"
          },
          {
            name: "Journal: Non-Open Access (Editor)",
            field: "editorialActivities",
            value: "25",
            score: (list) => list.length * 25,
            filter: (item) =>
              item.editorType == "Journal: Non-Open Access (Editor)"
          },
          {
            name: "Journal: Non-Open Access (Editorial Board Member)",
            field: "editorialActivities",
            value: "8",
            score: (list) => list.length * 8,
            filter: (item) =>
              item.editorType ==
              "Journal: Non-Open Access (Editorial Board Member)"
          },
          {
            name: "Journal: Open-Access or Online Only (Editoral Board)",
            field: "editorialActivities",
            value: "5",
            score: (list) => list.length * 5,
            filter: (item) =>
              item.editorType ==
              "Journal: Open-Access or Online Only (Editoral Board)"
          },
          {
            name: "Professional Newsletter Editor/Editorial Board Member (i.e. Subspeciality Society Newsletter, VSA Newsletter)",
            field: "editorialActivities",
            value: "5",
            score: (list) => list.length * 5,
            filter: (item) =>
              item.editorType ==
              "Professional Newsletter Editor/Editorial Board Member"
          },
          {
            name: "Journal: Invited article reviewer for PubMed indexed journal submission ",
            field: "editorialActivities",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.editorType ==
              "Journal: Invited article reviewer for PubMed indexed journal submission"
          },
          {
            name: "Reviewer for Meeting Submissions (i.e. workshops, poster abstracts, lectures)",
            field: "editorialActivities",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.editorType == "Reviewer for Meeting Submissions"
          },
          {
            name: "NIH Study Section Member ",
            field: "editorialActivities",
            value: "12",
            score: (list) => list.length * 12,
            filter: (item) => item.editorType == "NIH Study Section Member"
          },
          {
            name: "National or International Foundation Reviewer ",
            field: "editorialActivities",
            value: "10",
            score: (list) => list.length * 10,
            filter: (item) =>
              item.editorType == "National or International Foundation Reviewer"
          },
          {
            name: "Regional Foundation Reviewer",
            field: "editorialActivities",
            value: "5",
            score: (list) => list.length * 5,
            filter: (item) => item.editorType == "Regional Foundation Reviewer"
          }
        ]
      },
      {
        name: "Mentorship: Research Related",
        fields: ["mentoring"],
        list: [
          {
            name: "Research Project Mentor: Primary Mentor (Medical Student)",
            field: "mentoring",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) => item.type == "students"
          },
          {
            name: "Research Project Mentor: Primary Mentor (Resident)",
            field: "mentoring",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) => item.type == "residents"
          },
          {
            name: "Research Project Mentor: Primary Mentor (Graduate Student)",
            field: "mentoring",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) => item.type == "graduate"
          },
          {
            name: "Research Project Mentor: Primary Mentor (Junior Faculty Member)",
            field: "mentoring",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) => item.type == "faculty"
          }
        ]
      },
      {
        name: "Leadership: Research Related",
        fields: ["committeeService"],
        list: [
          {
            name: "IRB Member",
            field: "committeeService",
            value: "5",
            score: (list) => list.length * 5,
            filter: (item) =>
              item.membership == "Member" && item.subType == "IRB"
          },
          {
            name: "IRB Chair",
            field: "committeeService",
            value: "10",
            score: (list) => list.length * 10,
            filter: (item) =>
              item.membership == "Chair / Vice Chair" && item.subType == "IRB"
          }
        ]
      },
      {
        name: "Miscellaneous: Research Related",
        fields: ["honors"],
        list: [
          {
            name: "Local Meeting (i.e. UVA Based Presentation) Award",
            field: "honors",
            value: "0.2",
            score: (list) => list.length * 0.2,
            filter: (item) => item.subType == "Local Meeting Presentation Award"
          },
          {
            name: "Regional Meeting (i.e. VSA) Presentation Award",
            field: "honors",
            value: "0.5",
            score: (list) => list.length * 0.5,
            filter: (item) =>
              item.subType == "Regional Meeting Presentation Award"
          },
          {
            name: "National Meeting (i.e. ASA, Speciality meeting, SEA) Presentation Award",
            field: "honors",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.subType == "National Meeting Presentation Award"
          },
          {
            name: "Abstract/Poster Judge or Moderator at a Local Meeting",
            field: "editorialActivities",
            value: "0.4",
            score: (list) => list.length * 0.4,
            filter: (item) =>
              item.editorType ==
              "Abstract/Poster Judge or Moderator at a Local Meeting"
          },
          {
            name: "Abstract/Poster Judge or Moderator at a Regional Meeting",
            field: "editorialActivities",
            value: "0.6",
            score: (list) => list.length * 0.6,
            filter: (item) =>
              item.editorType ==
              "Abstract/Poster Judge or Moderator at a Regional Meeting"
          },
          {
            name: "Abstract/Poster Judge or Moderator at a National Meeting",
            field: "presentations",
            value: "1",
            score: (list) => list.length * 1,
            filter: (item) =>
              item.editorType ==
              "Abstract/Poster Judge or Moderator at a National Meeting"
          },
          {
            name: "Review of departmental research proposal",
            key: "researchProposalNum",
            unit: "proposal",
            value: "0.5",
            score: (num) => num * 0.5
          }
        ]
      },
      {
        name: "Other Activities",
        list: [
          {
            name: "Hours of Activity 1 (optional)",
            key: "researchActivity1",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 2 (optional)",
            key: "researchActivity2",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 3 (optional)",
            key: "researchActivity3",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 4 (optional)",
            key: "researchActivity4",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          },
          {
            name: "Hours of Activity 5 (optional)",
            key: "researchActivity5",
            unit: "hour",
            value: "0.2",
            score: (num) => num * 0.2
          }
        ]
      }
    ]
  },
  { name: "Totals" }
];

var getApawScores = function ({ newDef, viewYear, startDate, endDate }) {
  getKey(newDef, "career", {});
  var yearData = getKey(newDef.career, viewYear, {
    timeBreakdown: {},
    goals: {},
    status: "mentee",
    questions: {},
    mentorComments: ""
  });
  getKey(yearData, "details", {});

  var sectionTotals = apawStructure
    .filter((apawTab) => {
      return apawTab.sections != null;
    })
    .map((apawTab) => {
      var totalPoints = 0;
      (apawTab.sections ?? []).map(function (apawSection) {
        apawSection.list.map(function (item) {
          if (item.key != null) {
            var num = getKey(yearData.details, item.key, 0);
            var pts = parseFloat(item.score(num).toFixed(1));
            totalPoints += pts;
          } else {
            var list = getItemsWithinDateRange(
              getField(newDef, item.field),
              startDate,
              endDate
            ).filter((n) => item.filter(n, { startDate, endDate }));
            var num = list.length;
            var pts = parseFloat(item.score(list).toFixed(1));
            totalPoints += pts;
          }
        });
      });
      return { name: apawTab.name, points: totalPoints };
    });

  return sectionTotals;
};
export { getApawScores };

export default {
  title: "UVA Anes",
  tabTitle: "APAW",
  cvSetup: function ({
    contextMethods,
    contextConstants,
    contextState,
    conference,
    backend
  }) {
    let { refreshSection, updateLayout, checkSave } = contextMethods;
    let {
      user,
      cvOwner,
      users,
      hierarchyNames,
      mentors,
      conferences,
      formats
    } = contextConstants;
    let {
      section,
      sectionState,
      format,
      newDef,
      viewAsState,
      customExportSettings
    } = contextState;

    var editAccessOverride =
      (user.settings.accessFilters || []).length > 0 &&
      user.settings.conferenceTabAccess == "editAccess";
    var menteeOverride = false;
    var mentorOverride = false;

    var menteeAccess =
      user.id == cvOwner.id || editAccessOverride || menteeOverride;
    var overviewState = getKey(sectionState, section, {});

    var mentorAccess =
      (conference.mentors[user.id] || {})[cvOwner.id] != null ||
      editAccessOverride ||
      mentorOverride;
    var managerAccess = editAccessOverride;

    $("#fieldList").empty();

    $("#fieldList").append(
      $(
        "" +
          "<div>" +
          '   <div class="btn btn-default careerYearPrev" style="margin-right: 15px; margin-bottom: 8px;">' +
          '   <span class="glyphicon glyphicon-arrow-left"></span>' +
          "   </div>" +
          '   <h4 class="careerYear" style="margin-right: 15px;display: inline-block;margin-top: 7px;vertical-align: top;">Year: </h4>' +
          '   <div class="btn btn-default careerYearNext" style="margin-right: 15px;vertical-align: top;"><span class="glyphicon glyphicon-arrow-right"></span></div>' +
          '   <div class="btn btn-primary limitedCVCareerDownload" style="position: relative; margin-right: 5px; vertical-align: top; display: inline-block;">' +
          '     <span class="glyphicon glyphicon-download" style="margin-right: 5px;"></span>' +
          "     <span>Date Limited CV</span>" +
          "   </div>" +
          '   <div class="btn btn-primary fullDownload" style="position: relative; margin-right: 5px; vertical-align: top; display: inline-block;">' +
          '     <span class="glyphicon glyphicon-download" style="margin-right: 5px;"></span>' +
          "     <span>Full CV</span>" +
          "   </div>" +
          '   <div class="btn btn-primary apawDownload" style="position: relative; margin-right: 5px; vertical-align: top; display: inline-block;">' +
          '     <span class="glyphicon glyphicon-download" style="margin-right: 5px;"></span>' +
          "     <span>APAW Report</span>" +
          "   </div>" +
          " </div>"
      )
    );

    $(".limitedCVCareerDownload")
      .unbind("click")
      .click(function () {
        var overviewState = getKey(sectionState, section, {});

        var yearInfo = getCareerAvailableYears(
          newDef,
          conference,
          user,
          cvOwner
        );
        var availableYears = yearInfo.availableYears;
        var baseYear = yearInfo.baseYear;
        if (
          overviewState.yearIndex == null ||
          availableYears[overviewState.yearIndex] == null
        )
          overviewState.yearIndex = availableYears.findIndex(function (n) {
            return n == baseYear;
          });
        var viewYear = availableYears[overviewState.yearIndex];

        var cutoff = conference.cutoffDate || "1/1"; // Before this = last year. New section starts on this date
        var month = cutoff.split("/")[0] || "1";
        var date = cutoff.split("/")[1] || "1";

        customExportSettings.dateLimited = true;
        customExportSettings.shown = true;

        var endDate = new Date(
          viewYear + 1,
          parseInt(month) - 1,
          parseInt(date) - 1
        );
        $("#m1").val(month);
        $("#m2").val(endDate.getMonth() + 1);
        $("#d1").val(date);
        $("#d2").val(endDate.getDate());
        $("#y1").val(viewYear + (format == "stanford_anesthesia" ? -1 : 0));
        $("#y2").val(endDate.getFullYear());
        $(".download").trigger("click");
      });

    var mentorList = keys(conference.mentors).filter(function (id) {
      return conference.mentors[id][cvOwner.id] != null && mentors[id] != null;
    });

    if (mentorList.length > 0) {
      $("#fieldList").append(
        $(
          "" +
            '<div id="confSelectSection" style="margin-bottom: 10px;display: inline-block;width: 100%;">' +
            '  <h4 style="display: inline-block;margin-right: 5px;">APAW Mentor' +
            (mentorList.length > 1 ? "s" : "") +
            ": " +
            mentorList
              .map(function (mId) {
                return escapeHtml(mentors[mId].name);
              })
              .join(", ") +
            "</h4>" +
            "</div>"
        )
      );
    }

    $("#fieldList").append(
      $(
        "" +
          '<div style="margin-top: 8px;display: inline-block;width: 100%;">' +
          '  <h4 class="statusTitle" style="display: inline-block; margin-right: 5px;">Status: Mentee Editing</h4>' +
          '  <div class="btn nextStatus btn-success" style="vertical-align: top;margin-top: 3px;"></div>' +
          '  <div class="btn prevStatus btn-default" style="vertical-align: top;margin-top: 3px;"></div>' +
          '  <h5 class="errorSubheader" style="color: #ad310e;">Missing Information Required Before Submission</h5>' +
          '  <h5 class="statusSubheader">When finished, mark as complete to notify your mentor.</h5>' +
          "</div>"
      )
    );

    var last = getLastPosition(newDef, { format });
    if (
      last != null &&
      last.time != null &&
      last.time.start != null &&
      !isNaN(getYears(last.time.start))
    ) {
      var dateText = getDate(last);
      var yearsLong = Math.round(last.years * 10) / 10; // Math.round(((last.time.end != null && last.time.end != 'ongoing') ? getYears(last.time.end) : (new Date().getYear()+1900)) - getYears(last.time.start));
      $("#fieldList").append(
        $(
          "" +
            '<div style="margin-bottom: 10px;margin-top: 10px;">' +
            '  <h4 style="margin-bottom: 10px; display: inline-block;">Academic Title: <span id="careerConfCurrentTitle"><u class="sectionTab" data-section="facultyAppointments">' +
            escapeHtml(last.title) +
            " (" +
            escapeHtml(dateText) +
            ")</u> for " +
            yearsLong +
            " year" +
            (yearsLong != 1 ? "s" : "") +
            "</span></h4>" +
            "<div>"
        )
      );
    }

    var printableContents = $('<span id="printableContents"></span>');
    $("#fieldList").append(printableContents);

    // Find which years are available. Should be just years which have data or which are open, or if you have mentorAccess
    var yearInfo = getCareerAvailableYears(newDef, conference, user, cvOwner);
    var availableYears = yearInfo.availableYears;
    var baseYear = yearInfo.baseYear;

    var overviewState = getKey(sectionState, section, {});
    if (
      overviewState.yearIndex == null ||
      availableYears[overviewState.yearIndex] == null
    )
      overviewState.yearIndex = availableYears.findIndex(function (n) {
        return n == baseYear;
      });

    if (overviewState.apawTab == null) overviewState.apawTab = 0;

    printableContents.append(
      $(
        '<h5 style="margin-bottom: 10px;display: inline-block;margin-top: 20px;margin-right: 5px;">Section:</h5>'
      )
    );
    printableContents.append(
      $(
        '<select id="APAW_section_select" class="form-control" style="display: inline-block;width: auto;height: 30px;margin-right: 10px;">' +
          apawStructure
            .map(
              (n, i) =>
                `<option ${overviewState.apawTab == i ? "selected" : ""} value="${i}">${n.name}</option>`
            )
            .join("") +
          "</select>"
      )
    );
    printableContents.append(
      $(
        '<h5 style="display: inline-block;">Total points: <span id="APAW_totalPoints"></span></h5>'
      )
    );

    printableContents.append($('<div id="APAW_section"></div>'));

    $("#fieldList").append(
      $(
        "" +
          '<div style="margin-top: 8px;display: inline-block;width: 100%;">' +
          '  <h4 class="statusTitle" style="display: inline-block; margin-right: 5px;">Status: Mentee Editing</h4>' +
          '  <div class="btn nextStatus btn-success disabled" style="vertical-align: top; margin-top: 3px; display: inline-block;">Submit for Review</div>' +
          '  <div class="btn prevStatus btn-default" style="vertical-align: top; margin-top: 3px; display: none;"></div>' +
          '  <h5 class="errorSubheader" style="color: #ad310e;"></h5>' +
          '  <h5 class="statusSubheader" style="display: none;">When finished, submit for review to notify your mentor</h5>' +
          "</div>"
      )
    );

    var careerErrorCheck = function () {
      var overviewState = getKey(sectionState, section, {});
      // if (overviewState.yearIndex == null) overviewState.yearIndex = 0;
      if (
        overviewState.yearIndex == null ||
        availableYears[overviewState.yearIndex] == null
      )
        overviewState.yearIndex = availableYears.findIndex(function (n) {
          return n == baseYear;
        });
      var viewYear = availableYears[overviewState.yearIndex];

      var yearData = getKey(newDef.career, viewYear, {
        timeBreakdown: {},
        goals: {},
        status: "mentee",
        questions: {},
        mentorComments: ""
      });

      var lastYearData = newDef.career[viewYear - 1] || {
        timeBreakdown: {},
        goals: {},
        status: "mentee",
        questions: {},
        mentorComments: ""
      };

      var confYearData = conference.openYears[viewYear] || { open: false };
      var isOpen = !!confYearData.open || managerAccess; // For managers, it's always open.

      var errors = [];
      var hasError = false;

      if (!isOpen) {
        $(".statusSubheader").text("");
        $(".errorSubheader").text("");
      } else if (yearData.status == "mentee" && menteeAccess) {
        $(".statusSubheader").text(
          "When finished, submit for review to notify your mentor"
        );
        $(".errorSubheader").text(errors.join(", "));
      } else if (yearData.status == "mentor" && mentorAccess) {
        $(".statusSubheader").text("When finished, mark as finalized");
        $(".errorSubheader").text(
          "Missing information required before finalizing"
        );
      } else {
        $(".statusSubheader").text("");
        $(".errorSubheader").text("");
      }

      $(".statusSubheader").toggle(!hasError);
      $(".errorSubheader").toggle(hasError);

      $(".errorSubheader")
        .unbind("click")
        .click(function () {
          $(".has-error")[0].scrollIntoView();
        });
      $(".nextStatus").toggleClass("disabled", hasError);
    };

    var updateHTML = function (opts) {
      opts = opts || {};
      var overviewState = getKey(sectionState, section, {});
      // if (overviewState.yearIndex == null) overviewState.yearIndex = 0;
      if (
        overviewState.yearIndex == null ||
        availableYears[overviewState.yearIndex] == null
      )
        overviewState.yearIndex = availableYears.findIndex(function (n) {
          return n == baseYear;
        });
      var viewYear = availableYears[overviewState.yearIndex];

      var cutoff = conference.cutoffDate || "1/1"; // Before this = last year. New section starts on this date
      var month = cutoff.split("/")[0] || "1";
      var date = cutoff.split("/")[1] || "1";

      var startDate = new Date(month + "/" + date + "/" + viewYear).getTime();
      var endDate =
        new Date(month + "/" + date + "/" + (viewYear + 1)).getTime() -
        1000 * 60 * 60 * 24;

      var yearData = getKey(newDef.career, viewYear, {
        timeBreakdown: {},
        goals: {},
        status: "mentee",
        questions: {},
        mentorComments: "",
        details: {}
      });

      var lastYearData = newDef.career[viewYear - 1] || {
        timeBreakdown: {},
        goals: {},
        status: "mentee",
        questions: {},
        mentorComments: "",
        details: {}
      };

      getKey(yearData, "status", "mentee"); // mentee, mentor, finalized

      var confYearData = conference.openYears[viewYear] || { open: false };
      var isOpen = !!confYearData.open || managerAccess;

      var isReadOnly = function (yearData, type, thisOpts) {
        thisOpts = thisOpts || {};
        if (opts.readOnly) return true;
        var editAccessOverride =
          (user.settings.accessFilters || []).length > 0 &&
          user.settings.conferenceTabAccess == "editAccess";
        if (thisOpts.noOverride) editAccessOverride = false;
        var menteeOverride = false;
        var mentorOverride = false;

        if (viewAsState !== "undefined" && editAccessOverride) {
          editAccessOverride = false;
          if (viewAsState.career == "mentee") menteeOverride = true;
          else if (viewAsState.career == "mentor") mentorOverride = true;
          else editAccessOverride = true;
        }

        var menteeAccess =
          user.id == cvOwner.id || editAccessOverride || menteeOverride;
        var mentorAccess =
          (conference.mentors[user.id] || {})[cvOwner.id] != null ||
          editAccessOverride ||
          mentorOverride;
        return (
          !isOpen ||
          (yearData.status != type && !mentorAccess && !thisOpts.noOverride) ||
          (type == "mentee" && !menteeAccess) ||
          (type == "mentor" && !mentorAccess)
        );
      };

      $(".statusTitle").text(
        "Status: " +
          (!isOpen
            ? "Closed"
            : {
                mentee: "Mentee Editing",
                mentor: "Mentor Review",
                finalized: "Finalized"
              }[yearData.status])
      );

      $(".nextStatus, .prevStatus").hide();
      if (!isOpen) {
      } else if (yearData.status == "mentee") {
        if (menteeAccess) $(".nextStatus").show().text("Submit for Review");
      } else if (yearData.status == "mentor") {
        if (menteeAccess && !!confYearData.open)
          $(".prevStatus").show().text("Resume Editing");
        if (mentorAccess) $(".nextStatus").show().text("Finalize Review");
      } else if (yearData.status == "finalized") {
        if (mentorAccess) $(".prevStatus").show().text("Resume Review");
      }

      var getYearText = function (obj) {
        return (
          obj.getMonth() +
          1 +
          "/" +
          obj.getDate() +
          "/" +
          (obj.getYear() + 1900 + "").slice(-2)
        );
      };
      if (isNaN(startDate)) debugger;

      $(".careerYear").html(
        "<span>" +
          getYearText(new Date(startDate)) +
          " - " +
          getYearText(new Date(endDate)) +
          "</span>" +
          (!isOpen || yearData.status == "closed"
            ? '<span class="glyphicon glyphicon-lock" style="margin-left: 10px;"></span>'
            : "")
      );

      $(".careerYearPrev")
        .css("visibility", overviewState.yearIndex > 0 ? "" : "hidden")
        .unbind("click")
        .click(function () {
          // Only go back if previous data exists
          overviewState.yearIndex--;
          updateHTML();
        });
      $(".careerYearNext")
        .toggle(overviewState.yearIndex < availableYears.length - 1)
        .unbind("click")
        .click(function () {
          overviewState.yearIndex++;
          updateHTML();
        });

      $(".apawDownload")
        .unbind("click")
        .click(function () {
          var overviewState = getKey(sectionState, section, {});
          if (
            overviewState.yearIndex == null ||
            availableYears[overviewState.yearIndex] == null
          )
            overviewState.yearIndex = availableYears.findIndex(function (n) {
              return n == baseYear;
            });
          var viewYear = availableYears[overviewState.yearIndex];

          var cutoff = conference.cutoffDate || "1/1"; // Before this = last year. New section starts on this date
          var month = cutoff.split("/")[0] || "1";
          var date = cutoff.split("/")[1] || "1";

          var startDate = new Date(
            month + "/" + date + "/" + viewYear
          ).getTime();
          var endDate =
            new Date(month + "/" + date + "/" + (viewYear + 1)).getTime() -
            1000 * 60 * 60 * 24;

          var yearData = getKey(newDef.career, viewYear, {
            timeBreakdown: {},
            goals: {},
            status: "mentee",
            questions: {},
            mentorComments: "",
            details: {}
          });

          getKey(yearData, "details", {});

          var workbook = new ExcelJS.Workbook();

          apawStructure.map((apawTab) => {
            var sheet = workbook.addWorksheet(apawTab.name);
            var row_i = 1;

            if (apawTab.name == "Totals") {
              var sectionTotals = getApawScores({
                newDef,
                viewYear,
                startDate,
                endDate
              });

              var grandTotal = 0;
              sectionTotals.map((sectionTotal) => {
                var row = sheet.getRow(row_i);
                row.getCell(1).value = {
                  richText: [
                    {
                      font: { bold: true },
                      text: sectionTotal.name
                    }
                  ]
                };
                row.getCell(2).value = sectionTotal.points;
                row_i++;
                grandTotal += sectionTotal.points;
              });

              var row = sheet.getRow(row_i);
              row.getCell(1).value = {
                richText: [
                  {
                    font: { bold: true },
                    text: "Grand Total"
                  }
                ]
              };
              row.getCell(2).value = grandTotal;

              sheet.getColumn(1).width = 20;
              return;
            }

            sheet.getColumn(1).width = 60;
            sheet.getColumn(1).alignment = {
              wrapText: true,
              vertical: "middle",
              horizontal: "left"
            };
            sheet.getColumn(2).width = 10;
            sheet.getColumn(5).width = 60;

            (apawTab.sections ?? []).map(function (apawSection) {
              var topRow = sheet.getRow(row_i);
              var boldRow = (i, text) => {
                topRow.getCell(i).value = {
                  richText: [
                    {
                      font: { bold: true },
                      text
                    }
                  ]
                };
                topRow.getCell(i).fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "93C47D" }
                };
              };

              boldRow(1, apawSection.name);
              boldRow(2, "Credit Value");
              boldRow(3, "Amount");
              boldRow(4, "Points");
              boldRow(5, "Comment / Note");
              row_i++;

              apawSection.list.map(function (item) {
                let row = sheet.getRow(row_i);

                if (item.key != null) {
                  let num = getKey(yearData.details, item.key, 0);
                  let pts = parseFloat(item.score(num).toFixed(1));
                  let comment = getKey(
                    yearData.details,
                    item.key + "_note",
                    ""
                  );

                  row.getCell(1).value = item.name;
                  row.getCell(2).value = item.value;
                  row.getCell(3).value = num;
                  row.getCell(4).value = pts;
                  row.getCell(5).value = comment;
                } else {
                  let list = getItemsWithinDateRange(
                    getField(newDef, item.field),
                    startDate,
                    endDate
                  ).filter((n) => item.filter(n, { startDate, endDate }));
                  let num = list.length;
                  let pts = parseFloat(item.score(list).toFixed(1));

                  row.getCell(1).value = item.name;
                  row.getCell(2).value = item.value;
                  row.getCell(3).value = num;
                  row.getCell(4).value = pts;
                  row.getCell(5).value = list
                    .map((item) => {
                      return ["title", "location"]
                        .filter((n) => item[n] != null)
                        .map((n) => item[n])
                        .join(" - ");
                    })
                    .join(", ");
                }
                row_i++;
              });
            });
          });

          workbook.xlsx.writeBuffer().then(function (data) {
            saveAs(
              new Blob([data], { type: "application/octet-stream" }),
              (cvOwner.name || "") +
                " APAW Report_" +
                viewYear +
                "_" +
                (viewYear + 1) +
                ".xlsx"
            );
          });
        });

      careerErrorCheck();

      $(".nextStatus")
        .unbind("click")
        .click(function () {
          if ($(this).hasClass("disabled")) {
            $(".has-error")[0].scrollIntoView();
            return;
          }
          var yearData = newDef.career[viewYear];

          var logText = JSON.stringify({
            cvOwnerId: cvOwner.id,
            userId: user.id,
            data: newDef.career
          });
          backend.send("log", logText);
          // $.get('/log?text='+encodeURIComponent(logText));

          if (yearData.status == "mentee") {
            var check = confirm(
              "Are you sure you are ready to submit? This will send a notification to your mentor that you have completed this form."
            );
            if (!check) return;
            yearData.status = "mentor";
            getKey(yearData, "statusTimes", {})[yearData.status] = Date.now();

            backend.send("sendEmail", {
              type: "mentorAlert1",
              data: {
                mentorList: mentorList,
                cvOwnerId: cvOwner.id
              }
            });
          } else if (yearData.status == "mentor") {
            var check = confirm(
              "Are you sure you are ready to finalize? This will send a notification to your mentee that you have completed this review."
            );
            if (!check) return;
            yearData.status = "finalized";
            getKey(yearData, "statusTimes", {})[yearData.status] = Date.now();

            backend.send("sendEmail", {
              type: "menteeAlert1",
              data: {
                mentorId: user.id,
                cvOwnerId: cvOwner.id
              }
            });
          }
          checkSave();
          updateHTML();
        });

      $(".prevStatus")
        .unbind("click")
        .click(function () {
          if (yearData.status == "mentor") yearData.status = "mentee";
          else if (yearData.status == "finalized") yearData.status = "mentor";
          // getKey(yearData, 'statusTimes', {})[yearData.status] = Date.now();
          checkSave();
          updateHTML();
        });

      var apawTab = apawStructure[overviewState.apawTab];

      $("#APAW_section_select")
        .unbind("change")
        .on("change", function () {
          overviewState.apawTab = $(this).val();
          updateHTML();
        });

      var apawSectionEl = $("#APAW_section");
      apawSectionEl.empty();

      getKey(yearData, "details", {});

      var sectionTotals = getApawScores({
        newDef,
        viewYear,
        startDate,
        endDate
      });

      if (apawTab.name == "Totals") {
        sectionTotals.map((sectionTotal) => {
          $("#APAW_section").append(
            $(
              '<h4 style="display:block;margin-top: 20px;font-weight: normal;"><b>' +
                sectionTotal.name +
                ":</b> " +
                sectionTotal.points +
                " pt" +
                (sectionTotal.points == 1 ? "" : "s") +
                "</h4>"
            )
          );
        });
      } else {
        (apawTab.sections ?? []).map(function (apawSection, secI) {
          var sectionNames = (apawSection.fields || [])
            .map(function (section) {
              var inputFormat = formats[format].input || [];
              var sectionFormat = inputFormat.find(function (sectionFormat) {
                return (
                  (sectionFormat.section || sectionFormat.field) == section
                );
              });
              if (sectionFormat == null) return null;
              return (
                '<u class="sectionTab" data-section="' +
                section +
                '">' +
                sectionFormat.title +
                "</u>"
              );
            })
            .filter(function (n) {
              return n != null;
            });

          apawSectionEl.append(
            $(
              '<h5 style="margin-bottom: 10px; margin-top: 20px; font-weight: bold; text-decoration: underline;display: inline-block;">' +
                apawSection.name +
                "</h5>" +
                (sectionNames.length == 0
                  ? ""
                  : '<h5 style="display: inline-block;margin-left: 5px;">- Items found in ' +
                    sectionNames.join(", and ")) +
                "</h5>"
            )
          );

          apawSection.list.map(function (item, itemI) {
            if (item.key != null) {
              var num = getKey(yearData.details, item.key, 0);
              var comment = getKey(yearData.details, item.key + "_note", "");
              var pts = parseFloat(item.score(num).toFixed(1));

              apawSectionEl.append(
                $(
                  '<div class="APAW_section"><h5 style="cursor: pointer;" class="toggle_APAW_list" data-section="' +
                    secI +
                    '" data-item="' +
                    itemI +
                    '">' +
                    '<span class="toggle_APAW_list_icon glyphicon glyphicon-triangle-right" style="margin-right: 5px;"></span>' +
                    '<span style="' +
                    (num > 0 ? "color: green;" : "") +
                    '"><input class="APAW_num" value="' +
                    num +
                    '" style="width: 33px;padding: 2px;"> ' +
                    (item.unit || "item") +
                    's (<span class="APAW_pts">' +
                    pts +
                    " pt" +
                    (pts == 1 ? "" : "s") +
                    "</span>) - </span>" +
                    item.name +
                    "</h5>" +
                    '<div class="APAW_list" style="display: none; margin-left: 20px;" data-section="' +
                    secI +
                    '" data-item="' +
                    itemI +
                    '">' +
                    '<span style="display: block;font-style: italic;margin-bottom: 5px;">' +
                    "Points: " +
                    item.value +
                    " per " +
                    (item.unit || "item") +
                    "." +
                    "</span>" +
                    '<input type="text" class="form-control APAW_note" value="' +
                    escapeHtml(comment) +
                    '" style="display: inline-block;width: 500px;" placeholder="Optional Note">' +
                    "</div>" +
                    "</div>"
                )
              );
            } else {
              var getTitle = function (n) {
                return (
                  '<span class="glyphicon glyphicon-share-alt jump" data-field="' +
                  (item.section ?? item.field) +
                  '" data-id="' +
                  n.id +
                  '" style="margin-right: 5px;"></span>' +
                  escapeHtml(n.title || n.line || n.journal || "Untitled", {
                    allowTags: true
                  }) +
                  (n.impact == null || isNaN(parseFloat(n.impact))
                    ? ""
                    : " - IF: " + parseFloat(n.impact)) +
                  " (" +
                  getDate(n, "monthAndFullYear") +
                  ")"
                );
              };

              var list = getItemsWithinDateRange(
                getField(newDef, item.field),
                startDate,
                endDate
              ).filter((n) => item.filter(n, { startDate, endDate }));
              var num = list.length;
              var pts = parseFloat(item.score(list).toFixed(1));

              var sectionNames = [item.field]
                .map(function (section) {
                  var inputFormat = formats[format].input || [];
                  var sectionFormat = inputFormat.find(
                    function (sectionFormat) {
                      return (
                        (sectionFormat.section || sectionFormat.field) ==
                        section
                      );
                    }
                  );
                  if (sectionFormat == null) return null;
                  return (
                    '<u class="sectionTab" data-section="' +
                    section +
                    '">' +
                    sectionFormat.title +
                    "</u>"
                  );
                })
                .filter(function (n) {
                  return n != null;
                });

              apawSectionEl.append(
                $(
                  '<div class="APAW_section"><h5 style="cursor: pointer;" class="toggle_APAW_list" data-section="' +
                    secI +
                    '" data-item="' +
                    itemI +
                    '">' +
                    '<span class="toggle_APAW_list_icon glyphicon glyphicon-triangle-right" style="margin-right: 5px;"></span>' +
                    '<span style="' +
                    (list.length == 0 ? "" : "color: green;") +
                    '">' +
                    list.length +
                    " item" +
                    (list.length == 1 ? "" : "s") +
                    " (" +
                    pts +
                    " pt" +
                    (pts == 1 ? "" : "s") +
                    ") - </span>" +
                    item.name +
                    "</h5>" +
                    '<div class="APAW_list" style="display: none; margin-left: 20px;">' +
                    '<span style="display: block;font-style: italic;margin-bottom: 5px;">' +
                    "Points: " +
                    item.value +
                    " per item." +
                    ((apawSection.fields || []).length == 1
                      ? ""
                      : " Items found in the " +
                        sectionNames.join(", and ") +
                        " section" +
                        (sectionNames.length > 1 ? "s" : "") +
                        ":") +
                    "</span>" +
                    list.map(getTitle).join("<br>") +
                    "</div></div>"
                )
              );
            }
          });
        });
      }

      $("#APAW_totalPoints").text(_.sumBy(sectionTotals, (n) => n.points));

      $(".toggle_APAW_list")
        .unbind("click")
        .click(function () {
          var list = $(this).closest(".APAW_section").find(".APAW_list");
          if (list.length == 0) return;
          list.toggle(!list.is(":visible"));
          $(this)
            .find(".toggle_APAW_list_icon")
            .toggleClass("glyphicon-triangle-right", !list.is(":visible"))
            .toggleClass("glyphicon-triangle-bottom", list.is(":visible"));
        });

      $(".APAW_note")
        .unbind("input")
        .on("input", function (e) {
          var secI = getProp(this, "section");
          var itemI = getProp(this, "item");
          var apawItem = apawTab.sections[secI].list[itemI];
          var yearData = newDef.career[viewYear];
          yearData.details[apawItem.key + "_note"] = $(this).val();
          checkSave();
        });

      $(".APAW_num")
        .unbind("click")
        .on("click", function (e) {
          e.stopPropagation();
        });

      $(".APAW_num")
        .unbind("input")
        .on("input", function () {
          var secI = getProp(this, "section");
          var itemI = getProp(this, "item");
          var apawItem = apawTab.sections[secI].list[itemI];

          var newNum = parseInt($(this).val());
          if (isNaN(newNum)) return;

          var newPts = parseFloat(apawItem.score(newNum).toFixed(1));

          $(this)
            .closest(".APAW_section")
            .find(".APAW_pts")
            .text(newPts + " pt" + (newPts == 1 ? "" : "s"));
          $(this)
            .parent()
            .css("color", newNum > 0 ? "green" : "");

          var yearData = newDef.career[viewYear];
          yearData.details[apawItem.key] = newNum;

          var totalPoints = _.sumBy(
            getApawScores({ newDef, viewYear, startDate, endDate }),
            (n) => n.points
          );
          $("#APAW_totalPoints").text(totalPoints);

          checkSave();
        });

      $(".generalMentorComments")
        .toggle(!isReadOnly(yearData, "mentor"))
        .val(getKey(yearData, "mentorComments", ""))
        .parent()
        .toggleClass(
          "has-error",
          !isReadOnly(yearData, "mentor") &&
            (yearData.mentorComments || "").length == 0
        );

      $(".generalMentorCommentsText")
        .toggle(isReadOnly(yearData, "mentor"))
        .html(getKey(yearData, "mentorComments", "").split("\n").join("<br>"));

      $(".generalMentorComments")
        .unbind("input")
        .on("input", function () {
          var yearData = newDef.career[viewYear];
          yearData.mentorComments = $(this).val().trim();
          $(this)
            .parent()
            .toggleClass("has-error", yearData.mentorComments.length == 0);
          checkSave();
          careerErrorCheck();
        });

      updateLayout();
    };

    updateHTML();
  },
  manageSetup: function (
    settingsEl,
    { conference, updateConfDate, saveConference, hierarchyNames },
    user
  ) {
    const ccManage = new CCManage(conference, saveConference, updateConfDate, {
      includeSections: {
        cutoff: true,
        mentees: true,
        goals: false,
        questions: false,
        mentors: true,
        reminders: false,
        years: true
      },
      sortBy: "mentor",
      verbage: {
        mentor: "Mentor",
        mentee: "Mentee"
      }
    });
    ccManage.createSettingsElements(settingsEl);
    updateConfDate(conference);
    ccManage.createMentorsMenteesSection();
    ccManage.createAwesomplete();
    ccManage.hookMessageButton(user);
    ccManage.populateMenteesSection(hierarchyNames);
  }
};
